import axios from 'axios';
import Chart from 'react-apexcharts';
import DataTable from "react-data-table-component";
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import { Box, Typography, Paper, Grid, FormControl, Select, Tooltip, ListSubheader, MenuItem, CircularProgress, TextField, Chip, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, Tab, TablePagination, Avatar, Collapse, IconButton, Drawer } from '@mui/material';
import { Edit as EditIcon, Email as EmailIcon, Phone as PhoneIcon, Sms as SmsIcon, WhatsApp as WhatsAppIcon, TrendingUp as TrendingUpIcon, Person as PersonIcon, CalendarMonth as CalendarIcon, Refresh as RefreshIcon, CheckCircle as CheckCircleIcon, Error as ErrorIcon, Pause as PauseIcon, HourglassEmpty as HourglassIcon, PlayArrow as PlayIcon, KeyboardArrowDown as ExpandIcon, KeyboardArrowUp as CollapseIcon, SmartToy as AIIcon, Timeline as TimelineIcon, LinkedIn as LinkedInIcon, FlagCircle as FlagIcon, Close as CloseIcon, OpenInNew as LinkClickIcon, WarningAmberRounded as WarnIcon, Visibility as VisibilityIcon, TouchApp as TouchAppIcon, Celebration as CelebrationIcon, MarkEmailRead as MarkEmailReadIcon, Reply as ReplyIcon, Unsubscribe as UnsubscribeIcon, ErrorOutline as ErrorOutlineIcon } from '@mui/icons-material';

import './index.css';
import TitleRoute from '../../components/titleRoute.js';
import { ApiUrl } from '../../store/config';
import { getWorkspacePath } from '../../utils/workspaceUtils';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import AdvancedFilterModal from '../../components/Filters/AdvancedFilter';
import { buildMongoQuery } from '../../utils/filterConfig';
import { sanitizeEmailHtml } from '../../utils/emailSanitize';
import { getSalesAccounts, testSmtpConnection } from '../../store/Integration';
import TableAnimationFiles from '../../components/Animations/TableAnimationFiles.js';
import { borderRadius, fontSize, fontWeight, padding, textTransform } from '../../../node_modules/@mui/system/index';
import { toast } from 'react-toastify';
import { getSingleCampaign, getCampaignAnalytics, getCampaignContacts, getActivityFeed, getCampaignAuditLog, pauseCampaign, resumeCampaign } from '../../store/Campaign';
import { getAllPhones } from '../../store/Phone';
import AudienceColumn from './components/AudienceColumn';
import multipleUsersImg from '../../static/img/multiple-users.png';
import handshakeImg from '../../static/img/handshake.png';
import brokenHeartImg from '../../static/img/broken-heart.png';
import sadImg from '../../static/img/sad.png';
import checkedImg from '../../static/img/checked.png';

const PersonIconCard = ({ }) => (
  <svg width="19" height="25" viewBox="0 0 19 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.49994 0C12.5648 0 15.0494 2.48455 15.0494 5.54942C15.0494 8.61429 12.5648 11.0988 9.49994 11.0988C6.43513 11.0988 3.95053 8.61429 3.95053 5.54942C3.95344 2.48581 6.43623 0.00302196 9.49994 0ZM0 24.0989C0.0878017 21.5053 1.06593 19.1373 2.78009 17.3844C4.54953 15.5768 6.93403 14.5822 9.49989 14.5822C12.0658 14.5822 14.4505 15.5768 16.2197 17.3844C17.934 19.1373 18.912 21.5053 19 24.0989H0Z" fill="#34A853" /></svg>
);

const SearchIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <circle cx="6" cy="6" r="4.25" stroke="#9CA3AF" strokeWidth="1.5" />
    <path d="M10 10L12.5 12.5" stroke="#9CA3AF" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

const EmailIconCard = ({ }) => (
  <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M21.097 1.43656C21.1311 1.20805 21.1013 0.974552 21.0109 0.761932C20.9205 0.549312 20.773 0.365862 20.5848 0.231898C20.3965 0.0979333 20.1749 0.018681 19.9444 0.00291736C19.7139 -0.0128463 19.4835 0.0354936 19.2788 0.142584L0.672231 9.91121C0.455149 10.0242 0.27605 10.1985 0.157188 10.4124C0.0383252 10.6263 -0.0150616 10.8705 0.00366026 11.1145C0.0223821 11.3585 0.112387 11.5916 0.262493 11.7849C0.412599 11.9782 0.616189 12.1231 0.847968 12.2017L6.62962 14.1839L17.4291 4.09029L8.68937 14.8898L17.1287 17.783C17.302 17.8421 17.4861 17.8625 17.6682 17.8428C17.8502 17.823 18.0257 17.7636 18.1823 17.6687C18.3389 17.5737 18.4728 17.4457 18.5745 17.2934C18.6762 17.1412 18.7434 16.9685 18.7712 16.7875L21.097 1.43656ZM7.44645 15.5014V18.7118C7.44656 18.9528 7.5163 19.1887 7.6473 19.391C7.7783 19.5934 7.96497 19.7535 8.18485 19.8523C8.40473 19.951 8.64846 19.9841 8.88671 19.9476C9.12496 19.9111 9.34759 19.8065 9.52781 19.6464L12.3141 17.1704L7.44645 15.5014Z" fill="#F7931A" /></svg>
);

const TrendingUpIconCard = ({ }) => (
  <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.4688 5.9541V17.2732C24.0282 17.0916 23.5735 16.9461 23.1094 16.8382V16.3125C23.1084 15.7919 22.9586 15.2823 22.6776 14.844C22.3966 14.4056 21.9962 14.0567 21.5234 13.8385C21.0498 13.6306 20.5277 13.5587 20.0155 13.6307C19.5034 13.7028 19.0214 13.9159 18.6234 14.2463L13.3309 18.7775C13.0345 19.034 12.7969 19.3513 12.6343 19.7078C12.4716 20.0644 12.3878 20.4519 12.3884 20.8438H3.625C2.9046 20.8416 2.21433 20.5545 1.70493 20.0451C1.19553 19.5357 0.908402 18.8454 0.90625 18.125V5.9541L11.3191 12.035C11.7248 12.2631 12.1812 12.3859 12.6466 12.3923C13.112 12.3986 13.5716 12.2882 13.9834 12.0713C14.0085 12.061 14.0327 12.0489 14.0559 12.035L24.4688 5.9541Z" fill="#7F8BFA" /><path d="M12.228 10.4654C12.3751 10.5503 12.543 10.5924 12.7128 10.5868C12.8867 10.5705 13.055 10.5174 13.2067 10.4309L24.0908 4.07994C23.8543 3.66768 23.5135 3.3249 23.1026 3.08598C22.6917 2.84706 22.2252 2.72041 21.75 2.71875H3.62495C3.14952 2.72025 2.68284 2.84682 2.2718 3.08575C1.86075 3.32468 1.51981 3.66755 1.2832 4.07994L12.228 10.4654ZM26.061 20.4595C25.6357 20.031 25.1529 19.6638 24.6264 19.3684C23.6154 18.7749 22.4689 18.4513 21.2968 18.4286V16.3125C21.2968 16.1393 21.2472 15.9696 21.1538 15.8237C21.0604 15.6778 20.9271 15.5618 20.7697 15.4893C20.6124 15.4168 20.4375 15.391 20.2659 15.4148C20.0943 15.4386 19.9332 15.5111 19.8015 15.6237L14.5145 20.155C14.415 20.2401 14.3351 20.3457 14.2803 20.4646C14.2256 20.5835 14.1972 20.7128 14.1972 20.8438C14.1972 20.9747 14.2256 21.104 14.2803 21.2229C14.3351 21.3418 14.415 21.4474 14.5145 21.5325L19.8015 26.0637C19.9332 26.1764 20.0943 26.2489 20.2659 26.2727C20.4375 26.2965 20.6124 26.2707 20.7697 26.1982C20.9271 26.1257 21.0604 26.0097 21.1538 25.8638C21.2472 25.7179 21.2968 25.5482 21.2968 25.375V23.2625C22.3023 23.2878 23.2891 23.5398 24.1835 23.9997C25.078 24.4596 25.857 25.1156 26.4625 25.9188C26.5782 26.0689 26.7374 26.1797 26.9184 26.2361C27.0993 26.2925 27.2933 26.2918 27.4738 26.2341C27.6543 26.1742 27.8113 26.0589 27.9225 25.9047C28.0338 25.7505 28.0937 25.5652 28.0937 25.375C28.0952 24.4622 27.9164 23.5581 27.5676 22.7145C27.2188 21.871 26.7068 21.1046 26.061 20.4595Z" fill="#7F8BFA" /></svg>
);

const ResponseRateIconCard = ({ }) => (
  <svg width="25" height="17" viewBox="0 0 25 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23.4727 0H15.7536C15.3337 0 14.9929 0.340308 14.9929 0.760604V2.29696C14.9929 2.71678 15.3337 3.05756 15.7536 3.05756H19.0142L12.3424 9.72882L9.51394 6.90034C8.91663 6.3035 7.94872 6.3035 7.35141 6.90034L0.222928 14.0298C-0.0743092 14.3265 -0.0743092 14.8084 0.222928 15.1051L1.30917 16.1918C1.60593 16.4886 2.08776 16.4886 2.38452 16.1918L8.43291 10.1434L11.2609 12.9719C11.8582 13.5694 12.8262 13.5696 13.4235 12.9719L21.1758 5.21963V8.48024C21.1758 8.90007 21.5161 9.24085 21.9364 9.24085H23.4727C23.893 9.24085 24.2333 8.90007 24.2333 8.48024V0.760604C24.2333 0.340308 23.893 0 23.4727 0Z" fill="#EF4D56" /></svg>
);

const MeetingsIconCard = ({ }) => (
  <svg width="21" height="19" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.614321 14.7663H16.6932C16.8374 14.7663 16.9768 14.7158 17.0873 14.6239C17.2417 14.4946 20.7646 11.464 20.9794 4.9221H3.71106C3.49707 10.8604 0.25267 13.6515 0.218953 13.6794C0.0212898 13.8464 -0.0514342 14.1192 0.0374917 14.3619C0.125802 14.6041 0.355952 14.7663 0.614321 14.7663ZM20.3847 1.23052H17.3084V0.615262C17.3084 0.270715 17.0377 0 16.6931 0C16.3486 0 16.0779 0.270715 16.0779 0.615262V1.23052H12.9605V0.615262C12.9605 0.270715 12.6898 0 12.3453 0C12.0007 0 11.73 0.270715 11.73 0.615262V1.23052H8.65371V0.615262C8.65371 0.270715 8.38299 0 8.03845 0C7.6939 0 7.42318 0.270715 7.42318 0.615262V1.23052H4.34687C4.00233 1.23052 3.73161 1.50124 3.73161 1.84579V3.69157H21V1.84579C21 1.50124 20.7293 1.23052 20.3847 1.23052Z" fill="#6B21B0" /><path d="M17.8774 15.5673C17.5433 15.8455 17.124 15.9969 16.6932 15.9969H3.73163V17.8427C3.73163 18.1828 4.00681 18.458 4.34689 18.458H20.3847C20.7248 18.458 21 18.1828 21 17.8427V10.9458C19.8138 13.856 18.1585 15.3321 17.8774 15.5673Z" fill="#6B21B0" /></svg>
);

const CallsMadeIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" fill="#49AEFD" />
    <path d="M16 3h5v5" stroke="#49AEFD" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M21 3l-5.5 5.5" stroke="#49AEFD" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const CallsAnsweredIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" fill="#16a34a" />
    <path d="M15 5l2.5 2.5L21 4" stroke="#16a34a" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const VoicemailIcon = () => (
  <svg width="24" height="22" viewBox="0 0 26 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="6" cy="9" r="5" stroke="#F7931A" strokeWidth="2" />
    <circle cx="20" cy="9" r="5" stroke="#F7931A" strokeWidth="2" />
    <line x1="6" y1="14" x2="20" y2="14" stroke="#F7931A" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const AllStatusIcon = () => (
  <svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.93799 5.36064C8.88888 5.27268 8.81718 5.19941 8.73031 5.1484C8.64343 5.09739 8.54452 5.07049 8.44377 5.07046H5.05805L5.63791 0.63997C5.6548 0.511434 5.62707 0.380995 5.55936 0.270446C5.49164 0.159898 5.38803 0.0759352 5.26586 0.0325881C5.14368 -0.0107591 5.01032 -0.0108654 4.88807 0.0322869C4.76583 0.0754391 4.66209 0.159236 4.5942 0.269677L0.0838697 7.6049C0.0311197 7.6907 0.00220999 7.78901 0.000121746 7.88971C-0.0019665 7.9904 0.0228423 8.08983 0.0719898 8.17774C0.121137 8.26565 0.192845 8.33886 0.279717 8.38982C0.36659 8.44078 0.465483 8.46765 0.566199 8.46765H3.89629L3.37517 12.9052C3.36012 13.0333 3.38926 13.1627 3.45777 13.272C3.52628 13.3813 3.63006 13.464 3.75193 13.5062C3.8738 13.5485 4.00645 13.5479 4.12793 13.5045C4.24941 13.4611 4.35243 13.3776 4.41995 13.2677L8.92624 5.93328C8.97893 5.84749 9.0078 5.74921 9.00986 5.64855C9.01193 5.5479 8.98712 5.44851 8.93799 5.36064ZM4.79937 10.4871L5.09521 7.96784C5.10459 7.88843 5.09703 7.80794 5.07306 7.73166C5.04908 7.65538 5.00922 7.58505 4.9561 7.52529C4.90298 7.46552 4.8378 7.41769 4.76486 7.38494C4.69192 7.35218 4.61286 7.33525 4.53291 7.33525H1.57905L4.17139 3.11928L3.85156 5.5632C3.84111 5.64307 3.84782 5.72426 3.87125 5.80133C3.89468 5.8784 3.93428 5.94959 3.98742 6.01014C4.04055 6.07068 4.106 6.11919 4.17938 6.15243C4.25276 6.18566 4.33239 6.20285 4.41294 6.20286H7.43141L4.79937 10.4871Z" fill="currentColor" />
  </svg>
);

const HourglassPaddingIcon = () => (
  <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.73906 5.48752L7.24542 4.24415C7.58022 3.96909 7.77152 3.56259 7.77152 3.12026V1.12389H7.98684C8.0465 1.12391 8.10558 1.11217 8.16071 1.08934C8.21583 1.06652 8.26591 1.03306 8.3081 0.990869C8.35029 0.948682 8.38375 0.898595 8.40658 0.843471C8.4294 0.788347 8.44114 0.729267 8.44112 0.669604V0.454286C8.44114 0.394623 8.4294 0.335542 8.40658 0.280419C8.38375 0.225295 8.35029 0.175208 8.3081 0.133021C8.26591 0.0908331 8.21583 0.0573713 8.16071 0.0345471C8.10558 0.011723 8.0465 -1.63355e-05 7.98684 1.70605e-08H0.466358C0.406696 -1.63355e-05 0.347615 0.011723 0.292491 0.0345471C0.237368 0.0573713 0.187281 0.0908331 0.145093 0.133021C0.102906 0.175208 0.069444 0.225295 0.0466198 0.280419C0.0237956 0.335542 0.0120565 0.394623 0.0120728 0.454286V0.657532C0.0120565 0.717194 0.0237956 0.776275 0.0466198 0.831398C0.069444 0.886522 0.102906 0.936609 0.145093 0.978796C0.187281 1.02098 0.237368 1.05445 0.292491 1.07727C0.347615 1.10009 0.406696 1.11183 0.466358 1.11182H0.681553V3.10818C0.681553 3.5387 0.87285 3.94519 1.20765 4.23207L2.71401 5.47545C2.82167 5.55921 2.86959 5.67882 2.86959 5.81025V5.9896C2.86959 6.12116 2.80973 6.24076 2.71401 6.3244L1.19558 7.5918C0.860778 7.86673 0.669604 8.27322 0.669604 8.71569V10.7121H0.454286C0.394623 10.712 0.335543 10.7238 0.280419 10.7466C0.225295 10.7694 0.175208 10.8029 0.133021 10.8451C0.0908329 10.8873 0.0573712 10.9373 0.034547 10.9925C0.0117228 11.0476 -1.63355e-05 11.1067 1.70607e-08 11.1663V11.3696C-1.63355e-05 11.4292 0.0117228 11.4883 0.034547 11.5435C0.0573712 11.5986 0.0908329 11.6487 0.133021 11.6908C0.175208 11.733 0.225295 11.7665 0.280419 11.7893C0.335543 11.8121 0.394623 11.8239 0.454286 11.8239H7.97464C8.0343 11.8239 8.09338 11.8121 8.14851 11.7893C8.20363 11.7665 8.25372 11.733 8.29591 11.6908C8.33809 11.6487 8.37156 11.5986 8.39438 11.5435C8.4172 11.4883 8.42894 11.4292 8.42893 11.3696V11.1663C8.42894 11.1067 8.4172 11.0476 8.39438 10.9925C8.37156 10.9373 8.33809 10.8873 8.29591 10.8451C8.25372 10.8029 8.20363 10.7694 8.14851 10.7466C8.09338 10.7238 8.0343 10.712 7.97464 10.7121H7.75945V8.71569C7.75945 8.28517 7.56815 7.87868 7.23335 7.5918L5.73906 6.34842C5.6314 6.26466 5.58348 6.14505 5.58348 6.01362V5.83427C5.58348 5.69077 5.64335 5.57116 5.73906 5.48752ZM5.28477 6.89829L6.79113 8.14167C6.95853 8.28517 7.05412 8.48842 7.05412 8.70361V10.0636C7.05412 10.2324 6.98707 10.3942 6.86773 10.5136C6.74839 10.6329 6.58652 10.7 6.41775 10.7H2.0235C1.85472 10.7 1.69286 10.6329 1.57352 10.5136C1.45417 10.3942 1.38713 10.2324 1.38713 10.0636V8.71569C1.38713 8.50037 1.48271 8.28517 1.65011 8.15362L3.1566 6.91024C3.41959 6.69505 3.57504 6.36025 3.57504 6.01362V5.83427C3.57504 5.48752 3.41946 5.16467 3.1566 4.93752L1.65011 3.69415C1.48271 3.55065 1.38713 3.3474 1.38713 3.13221V1.76026C1.38713 1.59149 1.45417 1.42962 1.57352 1.31028C1.69286 1.19094 1.85472 1.12389 2.0235 1.12389H6.41775C6.58652 1.12389 6.74839 1.19094 6.86773 1.31028C6.98707 1.42962 7.05412 1.59149 7.05412 1.76026V3.12026C7.05412 3.33545 6.95853 3.55065 6.79113 3.6822L5.28465 4.9374C5.02166 5.15272 4.86621 5.4874 4.86621 5.83415V6.01337C4.86621 6.34817 5.00971 6.68298 5.28465 6.89817L5.28477 6.89829Z" fill="currentColor" />
    <path d="M6.43253 9.70296V10.0018C6.43247 10.0937 6.39591 10.1819 6.3309 10.2469C6.26588 10.3119 6.17773 10.3485 6.08578 10.3485H2.35566C2.26372 10.3485 2.17556 10.3119 2.11054 10.2469C2.04553 10.1819 2.00898 10.0937 2.00891 10.0018V9.70296C2.00941 9.56164 2.04069 9.42211 2.10058 9.29409C2.16046 9.16608 2.2475 9.05264 2.35566 8.96167L3.58709 7.93349C3.88592 7.68233 4.54358 7.68233 4.85436 7.93349L6.08578 8.96154C6.31305 9.14102 6.43253 9.41595 6.43253 9.70296Z" fill="currentColor" />
  </svg>
);

const StatCard = ({ title, value, subtitle, icon: Icon, color = 'primary', trend, className = "", }) => (
  <div className={`stat-card ${className}`}>
    <div className="icon">
      {Icon && <Icon sx={{ color: `${color}.main` }} />}
    </div>
    <div className="text-box">
      <div className="left-text">
        <h4>{title}</h4>
        <p>{subtitle}</p>
      </div>
      <h2>{value}</h2>
    </div>
  </div>
)

const channelConfig = {
  email: { icon: EmailIcon, color: '#120348', label: 'Email', sentKey: 'emailsSent', replyKey: 'emailsReplied', extraKeys: { opened: 'emailsOpened', clicked: 'emailsClicked', bounced: 'emailsBounced' } },
  sms: { icon: SmsIcon, color: '#0288d1', label: 'SMS', sentKey: 'smsSent', replyKey: 'smsReplied' },
  voice: { icon: PhoneIcon, color: '#49AEFD', label: 'Voice', sentKey: 'callsMade', replyKey: 'callsAnswered', extraKeys: { voicemail: 'callsVoicemail' } },
  whatsapp: { icon: WhatsAppIcon, color: '#25d366', label: 'WhatsApp', sentKey: 'whatsappSent', replyKey: 'whatsappReplied' },
  linkedin: { icon: LinkedInIcon, color: '#0077b5', label: 'LinkedIn', sentKey: 'linkedinSent', replyKey: 'linkedinReplied' }
};

const statusConfig = {
  pending: { color: '#6B7280', bg: '#F3F4F6', icon: HourglassPaddingIcon, label: 'Pending' },
  active: { color: '#16A34A', bg: '#EFF6FF', icon: PlayIcon, label: 'Active' },
  completed: { color: '#16A34A', bg: '#F0FDF4', icon: CheckCircleIcon, label: 'Completed' },
  failed: { color: '#DC2626', bg: '#FEF2F2', icon: ErrorIcon, label: 'Failed' },
  paused: { color: '#4285F4', bg: '#4285F412', icon: PauseIcon, label: 'Paused' },
  opted_out: { color: '#6B7280', bg: '#F3F4F6', icon: PersonIcon, label: 'Unsubscribed' },
  // Never sent — email failed verification (invalid/bounced/unverified/etc.) before send was attempted.
  skipped: { color: '#DC2626', bg: '#FEF2F2', icon: ErrorIcon, label: 'Invalid' }
}

const execStatusConfig = {
  processing: { color: '#2563EB', bg: '#EFF6FF', label: 'Processing' },
  success: { color: '#16A34A', bg: '#F0FDF4', label: 'Success' },
  failed: { color: '#DC2626', bg: '#FEF2F2', label: 'Failed' },
  skipped: { color: '#6B7280', bg: '#F3F4F6', label: 'Skipped' }
}

// Define columns outside the component
const contactColumns = (campaign, setSelectedContact, selectedContact, channelFlags = {}, currentWorkspaceId = null) => [
  {
    name: 'Contact',
    selector: row => [row.contactId?.firstName, row.contactId?.lastName].filter(Boolean).join(' ') || row.contactId?.company || '',
    sortable: false,
    cell: row => {
      const contact = row.contactId || {};
      const name = [contact.firstName, contact.lastName].filter(Boolean).join(' ') || contact.company || '';
      const contactHref = contact['_id'] && currentWorkspaceId
        ? `/${currentWorkspaceId}/contacts/${contact['_id']}`
        : contact['_id'] ? `/contacts/${contact['_id']}` : null;
      return (
        <div className="analytics-contact-cell">
          {name && <span className="analytics-contact-cell-name">{name}</span>}
          {contactHref && (
            <a
              className="analytics-contact-cell-link"
              href={contactHref}
              target="_blank"
              rel="noopener noreferrer"
              onClick={e => e.stopPropagation()}
              title="Open contact"
            >
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
            </a>
          )}
        </div>
      );
    },
  },
  {
    name: 'Email',
    selector: row => row.contactId?.email,
    sortable: false,
    cell: row => {
      const email = row.contactId?.email;
      if (!email) return <Typography variant="body2" color="textSecondary">—</Typography>;
      return (
        <div className="analytics-copyable-cell">
          <span className="analytics-copyable-cell-text">{email}</span>
          <button
            className="analytics-copyable-cell-btn"
            title="Copy email"
            onClick={e => { e.stopPropagation(); navigator.clipboard.writeText(email); }}
          >
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
          </button>
        </div>
      );
    },
  },
  {
    name: 'Phone',
    selector: row => row.contactId?.phone,
    sortable: false,
    width: '160px',
    cell: row => {
      const phone = row.contactId?.phone;
      if (!phone) return <Typography variant="body2" color="textSecondary">—</Typography>;
      return (
        <div className="analytics-copyable-cell">
          <span className="analytics-copyable-cell-text">{phone}</span>
          <button
            className="analytics-copyable-cell-btn"
            title="Copy phone"
            onClick={e => { e.stopPropagation(); navigator.clipboard.writeText(phone); }}
          >
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
          </button>
        </div>
      );
    },
  },
  {
    name: 'Company',
    selector: row => row.contactId?.company,
    sortable: false,
    cell: row => <Typography variant="body2">{row.contactId?.company || ''}</Typography>,
  },
  // {
  //   name: 'Email Provider',
  //   selector: row => row.contactId?.email,
  //   sortable: false,
  //   cell: row => {
  //     return (
  //       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
  //         <Box
  //           component="img"
  //           src="https://www.google.com/favicon.ico"
  //           alt="Gmail"
  //           sx={{ width: 16, height: 16, borderRadius: '3px', objectFit: 'contain' }}
  //           onError={(e) => { e.currentTarget.style.display = 'none'; }}
  //         />
  //         <h5>Gmail</h5>
  //       </Box>
  //     );
  //   },
  // },
  // {
  //   name: 'Email Security Gateway',
  //   selector: row => row.contactId?.email,
  //   sortable: false,
  //   cell: row => {
  //     return (
  //       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
  //         <Box
  //           component="img"
  //           src="https://play-lh.googleusercontent.com/bQ4hKVmAYWTDiYb3md-j2j7bWA4FtKaPgQvvw9bE6BbTvqw_0P9fSBlwubgpFR4sPIaB"
  //           alt="Gmail"
  //           sx={{ width: 16, height: 16, borderRadius: '3px', objectFit: 'contain' }}
  //           onError={(e) => { e.currentTarget.style.display = 'none'; }}
  //         />
  //         <h5>Proof Point</h5>
  //       </Box>
  //     );
  //   },
  // },
  {
    name: 'Status',
    selector: row => row.status,
    sortable: false,
    cell: row => {
      const { isVoiceCampaign: isVoice } = channelFlags;
      const chips = [];

      if (isVoice) {
        const voiceEntries = (row.executionHistory || []).filter(h => h.nodeType === 'voice');
        for (const entry of voiceEntries) {
          if (entry.status === 'success') {
            // Call outcome comes from the populated CallLog — the single source of truth
            const callLog = entry.activityId?.callLogId;
            if (!callLog) {
              chips.push({ label: 'Called', iconColor: '#6B7280', bgColor: '#F3F4F6', Icon: PhoneIcon });
            } else if (callLog.status === 'ongoing') {
              chips.push({ label: 'Calling…', iconColor: '#2563EB', bgColor: '#EFF6FF', Icon: PhoneIcon });
            } else if (callLog.status === 'ended') {
              const durMin = Number(callLog.callDuration) || 0;
              const durLabel = durMin > 0 ? ` • ${Math.floor(durMin)}m ${Math.round((durMin % 1) * 60)}s` : '';
              chips.push({ label: `Answered${durLabel}`, iconColor: '#16A34A', bgColor: '#F0FDF4', Icon: CheckCircleIcon });
              // Result comes from the CallLog successEvalution — readable lead status chip (legacy pass/fail rows get no result chip)
              const resultMeta = CALL_RESULT_META[callLog.successEvalution];
              if (resultMeta) chips.push({ label: resultMeta.label, iconColor: resultMeta.color, bgColor: resultMeta.bg, Icon: ['meeting_booked', 'interested'].includes(callLog.successEvalution) ? CheckCircleIcon : ErrorIcon });
              if (callLog.sentiment === 'positive') chips.push({ label: 'Positive', iconColor: '#16a34a', bgColor: 'rgba(34,197,94,.1)', Icon: CheckCircleIcon });
              else if (callLog.sentiment === 'negative') chips.push({ label: 'Negative', iconColor: '#DC2626', bgColor: '#FEF2F2', Icon: ErrorIcon });
            } else if (callLog.endReason === 'Call Rejected') {
              // Carrier/callee refused the dial (blocked caller ID, busy, declined) — distinct from nobody picking up
              chips.push({ label: 'Failed', iconColor: '#DC2626', bgColor: '#FEF2F2', Icon: ErrorIcon });
            } else {
              chips.push({ label: 'No Answer', iconColor: '#6B7280', bgColor: '#F3F4F6', Icon: PhoneIcon });
            }
          } else if (entry.status === 'failed') {
            chips.push({ label: 'Failed', iconColor: '#DC2626', bgColor: '#FEF2F2', Icon: ErrorIcon });
          } else if (entry.status === 'skipped') {
            chips.push({ label: 'Skipped', iconColor: '#6B7280', bgColor: '#F3F4F6', Icon: HourglassIcon });
          }
        }
        if (chips.length === 0) {
          const cfg = statusConfig[row.status] || statusConfig['pending'];
          chips.push({ label: cfg.label, iconColor: '#6B7280', bgColor: '#F3F4F6', Icon: HourglassIcon });
        }
      } else {
        const events = row.emailEvents || [];
        const hasSent = events.some(e => e.type === 'sent');
        const hasOpen = events.some(e => e.type === 'open');
        const hasReply = events.some(e => e.type === 'reply');
        const hasBounce = events.some(e => e.type === 'bounce');
        const hasUnsubscribe = events.some(e => e.type === 'unsubscribe');
        const hasClick = events.some(e => e.type === 'click');

        if (row.status === 'opted_out' || hasUnsubscribe) {
          chips.push({ label: 'Unsubscribed', iconColor: '#6B7280', bgColor: '#F3F4F6', Icon: PersonIcon });
        } else {
          if (hasSent) chips.push({ label: 'Contacted', iconColor: '#16A34A', bgColor: '#F0FDF4', Icon: CheckCircleIcon });
          if (hasOpen) chips.push({ label: 'Opened', iconColor: '#2563EB', bgColor: '#EFF6FF', Icon: EmailIcon });
          if (hasClick) chips.push({ label: 'Link Clicked', iconColor: '#D97706', bgColor: '#FFFBEB', Icon: LinkClickIcon });
          if (hasReply) chips.push({ label: 'Replied', iconColor: '#7C3AED', bgColor: '#F5F3FF', Icon: CheckCircleIcon });
          if (hasBounce) chips.push({ label: 'Bounced', iconColor: '#DC2626', bgColor: '#FEF2F2', Icon: ErrorIcon });
          if (chips.length === 0) {
            const cfg = statusConfig[row.status] || statusConfig['pending'];
            chips.push({ label: cfg.label, iconColor: cfg.color, bgColor: cfg.bg, Icon: cfg.icon });
          }
        }
      }

      return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.5, py: 0.75 }}>
          {chips.map(({ label, iconColor, bgColor, Icon }, i) => (
            <Box key={i} sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, borderRadius: '6px', px: 1, py: 0.4, background: bgColor, whiteSpace: 'nowrap' }}>
              <Icon sx={{ fontSize: 13, color: iconColor }} />
              <Typography fontWeight={600} sx={{ fontSize: 11.5, color: iconColor, lineHeight: 1 }}>{label}</Typography>
            </Box>
          ))}
        </Box>
      );
    },
  },
  {
    name: 'Current Step',
    selector: row => row.currentNodeId,
    cell: row => {
      const currentNode = (campaign?.sequence?.nodes || []).find(n => n.id === row.currentNodeId);
      return (
        <Typography variant="body2" color="textSecondary">
          {currentNode?.name || (row.status === 'completed' ? 'Completed' : '-')}
        </Typography>
      );
    },
  },
  {
    name: channelFlags['isVoiceCampaign'] ? 'Calls Made'
      : channelFlags['isSMSCampaign'] ? 'SMS Sent'
        : channelFlags['isLinkedInCampaign'] ? 'Messages Sent'
          : 'Emails Sent',
    selector: row => row.executionHistory,
    sortable: false,
    center: true,
    cell: row => {
      const nodeType = channelFlags['isVoiceCampaign'] ? 'voice'
        : channelFlags['isSMSCampaign'] ? 'sms'
          : channelFlags['isLinkedInCampaign'] ? 'linkedin'
            : 'email';
      const count = (row.executionHistory || []).filter(
        h => h.nodeType === nodeType && h.status === 'success'
      ).length;
      return <Typography variant="body2">{count}</Typography>;
    },
    width: '120px',
  },
  {
    name: 'Last Activity',
    selector: row => row.enrolledAt,
    sortable: false,
    cell: row => {
      const lastEntry = (row.executionHistory || []).slice(-1)[0];
      const lastActivity = lastEntry?.completedAt
        ? new Date(lastEntry.completedAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })
        : row.enrolledAt
          ? new Date(row.enrolledAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })
          : '-';
      return (
        <Box>
          <Typography variant="body2" color="textSecondary">{lastActivity}</Typography>
          {row.lastError && (
            <Typography
              variant="body2"
              sx={{ display: 'block', color: '#DC2626', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
            >
              {row.lastError}
            </Typography>
          )}
        </Box>
      );
    },
  },
];

// Channel-aware field options for the contacts Export CSV dropdown — keys map 1:1 to the server CSV columns
const exportFieldOptions = ({ isVoiceCampaign, isEmailCampaign }) => [
  { key: 'name', label: 'Name' }, { key: 'email', label: 'Email' }, { key: 'phone', label: 'Phone' }, { key: 'company', label: 'Company' }, { key: 'status', label: 'Status' },{ key: 'currentStep', label: 'Current Step' },{ key: 'messagesSent', label: isVoiceCampaign ? 'Calls Made' : 'Messages Sent' }, { key: 'lastActivity', label: 'Last Activity' }, { key: 'enrolledAt', label: 'Enrolled At' },
  ...(isVoiceCampaign ? [{ key: 'callStatus', label: 'Call Status' }, { key: 'callDuration', label: 'Call Duration' }, { key: 'callResult', label: 'Call Result' }, { key: 'sentiment', label: 'Sentiment' }, { key: 'endReason', label: 'End Reason' }, { key: 'callCost', label: 'Call Cost' }, { key: 'recordingUrl', label: 'Recording URL' }, { key: 'transcript', label: 'Transcript' }, ] : []),
  ...(isEmailCampaign ? [{ key: 'opens', label: 'Opens' }, { key: 'replies', label: 'Replies' }, { key: 'clicks', label: 'Link Clicks' }, { key: 'bounces', label: 'Bounces' }, { key: 'unsubscribed', label: 'Unsubscribed' }, ] : []),
];


const buildOrderedNodeList = (nodes, edges, entryNodeId) => {
  if (!nodes || nodes.length === 0) return [];
  const nodeMap = {};
  nodes.forEach(n => { nodeMap[n['id']] = n; });
  const edgeMap = {};
  (edges || []).forEach(e => { edgeMap[e['source']] = e['target']; });
  const ordered = [];
  const visited = new Set();
  let currentId = entryNodeId || nodes[0]?.['id'];
  while (currentId && nodeMap[currentId] && !visited.has(currentId)) {
    visited.add(currentId);
    ordered.push(nodeMap[currentId]);
    currentId = edgeMap[currentId];
  }
  if (ordered.length < nodes.length) {
    const remaining = nodes.filter(n => !visited.has(n['id'])).sort((a, b) => (a['position'] || 0) - (b['position'] || 0));
    ordered.push(...remaining);
  }
  return ordered;
};
const EmailNodeIcon = () => (
  <svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.21538 5.59033L8.02425 6.78549C7.54123 7.27021 6.69135 7.28065 6.19788 6.78549L5.0067 5.59033L0.728516 9.8824C0.887764 9.95604 1.06335 9.99999 1.25001 9.99999H12.9721C13.1588 9.99999 13.3343 9.9561 13.4935 9.88243L9.21538 5.59033Z" fill="#120348" />
    <path d="M12.9721 0H1.24999C1.06332 0 0.887742 0.0439441 0.728549 0.117582L5.30009 4.70429C5.3004 4.7046 5.30076 4.70465 5.30106 4.70496C5.30125 4.70516 5.30138 4.70541 5.30142 4.70568L6.78788 6.19705C6.94577 6.35494 7.27638 6.35494 7.43426 6.19705L8.92042 4.70593C8.92042 4.70593 8.92078 4.70526 8.92108 4.70496C8.92108 4.70496 8.92175 4.7046 8.92206 4.70429L13.4935 0.117555C13.3343 0.0438886 13.1588 0 12.9721 0ZM0.132943 0.700327C0.0505551 0.866936 0 1.05188 0 1.24999V8.74992C0 8.94803 0.0504995 9.13297 0.132915 9.29958L4.41851 5.00009L0.132943 0.700327ZM14.0891 0.700271L9.80361 5.00009L14.0891 9.29964C14.1715 9.13303 14.2221 8.94808 14.2221 8.74992V1.24999C14.2221 1.05182 14.1715 0.866881 14.0891 0.700271Z" fill="#120348" />
  </svg>
);

const HourglassNodeIcon = () => (
  <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.73906 5.48752L7.24542 4.24415C7.58022 3.96909 7.77152 3.56259 7.77152 3.12026V1.12389H7.98684C8.0465 1.12391 8.10558 1.11217 8.16071 1.08934C8.21583 1.06652 8.26591 1.03306 8.3081 0.990869C8.35029 0.948682 8.38375 0.898595 8.40658 0.843471C8.4294 0.788347 8.44114 0.729267 8.44112 0.669604V0.454286C8.44114 0.394623 8.4294 0.335542 8.40658 0.280419C8.38375 0.225295 8.35029 0.175208 8.3081 0.133021C8.26591 0.0908331 8.21583 0.0573713 8.16071 0.0345471C8.10558 0.011723 8.0465 -1.63355e-05 7.98684 1.70605e-08H0.466358C0.406696 -1.63355e-05 0.347615 0.011723 0.292491 0.0345471C0.237368 0.0573713 0.187281 0.0908331 0.145093 0.133021C0.102906 0.175208 0.069444 0.225295 0.0466198 0.280419C0.0237956 0.335542 0.0120565 0.394623 0.0120728 0.454286V0.657532C0.0120565 0.717194 0.0237956 0.776275 0.0466198 0.831398C0.069444 0.886522 0.102906 0.936609 0.145093 0.978796C0.187281 1.02098 0.237368 1.05445 0.292491 1.07727C0.347615 1.10009 0.406696 1.11183 0.466358 1.11182H0.681553V3.10818C0.681553 3.5387 0.87285 3.94519 1.20765 4.23207L2.71401 5.47545C2.82167 5.55921 2.86959 5.67882 2.86959 5.81025V5.9896C2.86959 6.12116 2.80973 6.24076 2.71401 6.3244L1.19558 7.5918C0.860778 7.86673 0.669604 8.27322 0.669604 8.71569V10.7121H0.454286C0.394623 10.712 0.335543 10.7238 0.280419 10.7466C0.225295 10.7694 0.175208 10.8029 0.133021 10.8451C0.0908329 10.8873 0.0573712 10.9373 0.034547 10.9925C0.0117228 11.0476 -1.63355e-05 11.1067 1.70607e-08 11.1663V11.3696C-1.63355e-05 11.4292 0.0117228 11.4883 0.034547 11.5435C0.0573712 11.5986 0.0908329 11.6487 0.133021 11.6908C0.175208 11.733 0.225295 11.7665 0.280419 11.7893C0.335543 11.8121 0.394623 11.8239 0.454286 11.8239H7.97464C8.0343 11.8239 8.09338 11.8121 8.14851 11.7893C8.20363 11.7665 8.25372 11.733 8.29591 11.6908C8.33809 11.6487 8.37156 11.5986 8.39438 11.5435C8.4172 11.4883 8.42894 11.4292 8.42893 11.3696V11.1663C8.42894 11.1067 8.4172 11.0476 8.39438 10.9925C8.37156 10.9373 8.33809 10.8873 8.29591 10.8451C8.25372 10.8029 8.20363 10.7694 8.14851 10.7466C8.09338 10.7238 8.0343 10.712 7.97464 10.7121H7.75945V8.71569C7.75945 8.28517 7.56815 7.87868 7.23335 7.5918L5.73906 6.34842C5.6314 6.26466 5.58348 6.14505 5.58348 6.01362V5.83427C5.58348 5.69077 5.64335 5.57116 5.73906 5.48752ZM5.28477 6.89829L6.79113 8.14167C6.95853 8.28517 7.05412 8.48842 7.05412 8.70361V10.0636C7.05412 10.2324 6.98707 10.3942 6.86773 10.5136C6.74839 10.6329 6.58652 10.7 6.41775 10.7H2.0235C1.85472 10.7 1.69286 10.6329 1.57352 10.5136C1.45417 10.3942 1.38713 10.2324 1.38713 10.0636V8.71569C1.38713 8.50037 1.48271 8.28517 1.65011 8.15362L3.1566 6.91024C3.41959 6.69505 3.57504 6.36025 3.57504 6.01362V5.83427C3.57504 5.48752 3.41946 5.16467 3.1566 4.93752L1.65011 3.69415C1.48271 3.55065 1.38713 3.3474 1.38713 3.13221V1.76026C1.38713 1.59149 1.45417 1.42962 1.57352 1.31028C1.69286 1.19094 1.85472 1.12389 2.0235 1.12389H6.41775C6.58652 1.12389 6.74839 1.19094 6.86773 1.31028C6.98707 1.42962 7.05412 1.59149 7.05412 1.76026V3.12026C7.05412 3.33545 6.95853 3.55065 6.79113 3.6822L5.28465 4.9374C5.02166 5.15272 4.86621 5.4874 4.86621 5.83415V6.01337C4.86621 6.34817 5.00971 6.68298 5.28465 6.89817L5.28477 6.89829Z" fill="currentColor" />
    <path d="M6.43253 9.70296V10.0018C6.43247 10.0937 6.39591 10.1819 6.3309 10.2469C6.26588 10.3119 6.17773 10.3485 6.08578 10.3485H2.35566C2.26372 10.3485 2.17556 10.3119 2.11054 10.2469C2.04553 10.1819 2.00898 10.0937 2.00891 10.0018V9.70296C2.00941 9.56164 2.04069 9.42211 2.10058 9.29409C2.16046 9.16608 2.2475 9.05264 2.35566 8.96167L3.58709 7.93349C3.88592 7.68233 4.54358 7.68233 4.85436 7.93349L6.08578 8.96154C6.31305 9.14102 6.43253 9.41595 6.43253 9.70296Z" fill="currentColor" />
  </svg>
);

const DeleyNodeIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.61035 0.205566V2.34348H11.7481L9.61035 0.205566Z" fill="#6B21B0" />
    <path d="M9.25681 3.04686C9.06265 3.04686 8.90525 2.88946 8.90525 2.6953V0H3.86621C3.28465 0 2.81152 0.473131 2.81152 1.05468V4.98488C2.92735 4.97438 3.04456 4.96873 3.16308 4.96873C4.36139 4.96873 5.4341 5.5166 6.14399 6.37497H9.95993C10.1541 6.37497 10.3115 6.53238 10.3115 6.72653C10.3115 6.92069 10.1541 7.07809 9.95993 7.07809H6.60716C6.83178 7.51639 6.96994 7.99382 7.01411 8.48434H9.95993C10.1541 8.48434 10.3115 8.64174 10.3115 8.8359C10.3115 9.03005 10.1541 9.18746 9.95993 9.18746H7.01411C6.90897 10.3485 6.28862 11.3631 5.38396 11.9999H10.8974C11.479 11.9999 11.9521 11.5268 11.9521 10.9453V3.04686H9.25681ZM9.95993 4.96873H4.8037C4.60955 4.96873 4.45214 4.81132 4.45214 4.61717C4.45214 4.42301 4.60955 4.26561 4.8037 4.26561H9.95993C10.1541 4.26561 10.3115 4.42301 10.3115 4.61717C10.3115 4.81132 10.1541 4.96873 9.95993 4.96873Z" fill="#6B21B0" />
    <path d="M3.16405 5.67188C1.41939 5.67188 0 7.09127 0 8.83592C0 10.5806 1.41939 12 3.16405 12C4.9087 12 6.3281 10.5806 6.3281 8.83592C6.3281 7.09127 4.9087 5.67188 3.16405 5.67188ZM4.10154 9.18748H3.16405C2.96989 9.18748 2.81249 9.03008 2.81249 8.83592V7.42968C2.81249 7.23552 2.96989 7.07812 3.16405 7.07812C3.3582 7.07812 3.51561 7.23552 3.51561 7.42968V8.48436H4.10154C4.2957 8.48436 4.4531 8.64177 4.4531 8.83592C4.4531 9.03008 4.2957 9.18748 4.10154 9.18748Z" fill="#6B21B0" />
  </svg>
);



const nodeTypeIcons = { email: EmailNodeIcon, voice: PhoneIcon, sms: SmsIcon, whatsapp: WhatsAppIcon, linkedin: LinkedInIcon, delay: HourglassNodeIcon, end: FlagIcon, condition: TimelineIcon };
const nodeTypeColors = { email: '#120348', voice: 'var(--primary-color)', sms: '#0288d1', whatsapp: '#25d366', linkedin: '#0077b5', delay: 'currentColor', end: '#16A34A', condition: '#EF4D56' };

// Map a channel-health status to a badge tone/icon/label for the Channel Health panel
const channelHealthBadge = (health) => {
  if (health === 'needs_reconnect') return { tone: 'error', icon: 'fa-exclamation-circle', label: 'Needs reconnect' };
  if (health === 'limit_reached') return { tone: 'warn', icon: 'fa-clock-o', label: 'Daily limit reached' };
  return { tone: 'ok', icon: 'fa-check-circle', label: 'Active' };
};

const classifyFailure = (row) => {
  const health = row['health'] || '';
  const err = (row['lastError'] || row['connectionError'] || '').toLowerCase();
  if (health === 'needs_reconnect' || /eauth|535|badcredentials|invalid login|password not accepted|authentication failed/.test(err))
    return { category: 'Mailbox disconnected', tone: 'error', hint: 'Your email password or permissions changed. Go to Connections and reconnect this mailbox.' };
  // 550-5.4.5 / 550-5.2.1 = hard daily quota enforced by Google
  if (health === 'limit_reached' || /daily (user )?sending (limit|quota)|5\.4\.5|5\.2\.1|too many messages|message rate exceeded/.test(err))
    return { category: 'Daily limit hit', tone: 'warn', hint: 'This mailbox reached its daily sending limit set by Google. Lower the daily limit in mailbox settings to avoid this.' };
  // 451 = Google temporary reputation / rate throttle (not a hard quota)
  if (/451|temporarily rejected|sending rate|try again later/.test(err))
    return { category: 'Sending too fast', tone: 'warn', hint: 'Google slowed down this mailbox because emails are going out too quickly. Lower the daily limit in mailbox settings.' };
  if (/timeout|econnection|etimedout|enotfound|service unavailable/.test(err))
    return { category: 'Could not connect', tone: 'warn', hint: 'We could not reach the mail server at that moment. These emails will be retried automatically.' };
  if (/user unknown|mailbox not found|does not exist|no such user|invalid recipient|address rejected/.test(err))
    return { category: 'Invalid email address', tone: 'error', hint: 'The contact\'s email address does not exist or was rejected. Check the address and update the contact.' };
  if (/bounce|mailer-daemon|postmaster/.test(err))
    return { category: 'Email bounced', tone: 'error', hint: 'The email was returned undelivered. The contact\'s address may be wrong or inactive.' };
  return { category: 'Failed to send', tone: 'warn', hint: '' };
};

const getTimelineNodeStyle = (timelineStatus, nodeType) => {
  const color = nodeTypeColors[nodeType] || '#6B7280';
  switch (timelineStatus) {
    case 'completed': return { borderColor: '#16A34A', bgColor: '#F0FDF4', iconColor: '#16A34A', lineColor: '#16A34A' };
    case 'failed': return { borderColor: '#DC2626', bgColor: '#FEF2F2', iconColor: '#DC2626', lineColor: '#DC2626' };
    case 'skipped': return { borderColor: '#6B7280', bgColor: '#F3F4F6', iconColor: '#6B7280', lineColor: '#6B7280' };
    case 'current-active':
    case 'current-waiting': return { borderColor: color, bgColor: `${color}15`, iconColor: color, lineColor: '#E5E7EB' };
    case 'upcoming':
    default: return { borderColor: '#D1D5DB', bgColor: '#F9FAFB', iconColor: '#D1D5DB', lineColor: '#E5E7EB' };
  }
};

const getDelayMs = (config) => {
  const amount = config?.['duration'] || config?.['days'] || config?.['value'] || 1;
  const unit = config?.['unit'] || 'days';
  const multipliers = { minutes: 60000, hours: 3600000, days: 86400000, weeks: 604800000 };
  return amount * (multipliers[unit] || 86400000);
};

const CountdownTimer = ({ targetDate }) => {
  const [timeLeft, setTimeLeft] = useState('');
  useEffect(() => {
    if (!targetDate) return;
    const calculate = () => {
      const diff = new Date(targetDate).getTime() - Date.now();
      if (diff <= 0) { setTimeLeft('Processing soon...'); return; }
      const days = Math.floor(diff / 86400000);
      const hours = Math.floor((diff % 86400000) / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);
      const parts = [];
      if (days > 0) parts.push(`${days}d`);
      if (hours > 0) parts.push(`${hours}h`);
      if (minutes > 0) parts.push(`${minutes}m`);
      parts.push(`${seconds}s`);
      setTimeLeft(parts.join(' '));
    };
    calculate();
    const interval = setInterval(calculate, 1000);
    return () => clearInterval(interval);
  }, [targetDate]);
  if (!targetDate) return null;
  // const execDate = new Date(targetDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, ml: 0.5 }}>
      <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, px: 1, py: 0.5, bgcolor: '#F7931A1F', borderRadius: 25, width: 'fit-content' }}>
        <svg width="4" height="5" viewBox="0 0 4 5" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2.69194 1.9805C3.02345 1.67826 3.47175 1.2695 3.51261 0.292969H3.80859V0H0V0.292969H0.295986C0.336846 1.2695 0.785146 1.67826 1.11665 1.9805C1.33902 2.18324 1.46484 2.30733 1.46484 2.5C1.46484 2.69267 1.33902 2.81676 1.11665 3.0195C0.785146 3.32174 0.336846 3.7305 0.295986 4.70703H0V5H3.80859V4.70703H3.51261C3.47175 3.7305 3.02345 3.32174 2.69194 3.0195C2.46957 2.81676 2.34375 2.69267 2.34375 2.5C2.34375 2.30733 2.46957 2.18324 2.69194 1.9805ZM1.75781 3.59803C1.7121 3.60744 1.66738 3.62116 1.62425 3.63899L0.727012 4.01027C0.873535 3.63771 1.10953 3.42245 1.31403 3.23601C1.54226 3.02793 1.75781 2.8314 1.75781 2.5V3.59803ZM2.49456 3.23601C2.69906 3.42245 2.93505 3.63771 3.08158 4.01026L2.18435 3.63898C2.14121 3.62115 2.09649 3.60743 2.05078 3.59802V2.5C2.05078 2.8314 2.26634 3.02793 2.49456 3.23601ZM0.721865 0.976562C0.651035 0.792002 0.602119 0.56916 0.589316 0.292969H3.21927C3.20647 0.56916 3.15756 0.792002 3.08672 0.976562H0.721865Z" fill="#F7931A" />
        </svg>
        <Typography variant="caption" sx={{ fontWeight: 600, color: '#F7931A', fontFamily: 'monospace', fontSize: 9 }}>{timeLeft}</Typography>
      </Box>
      {/* <Typography variant="caption" sx={{ color: '#6B7280', fontSize: 11 }}>Executes: {execDate}</Typography> */}
    </Box>
  );
};

const ContactExecutionHistory = ({ history, sequenceNodes, sequenceEdges, entryNodeId, currentNodeId, nextProcessAt, contactStatus, enrolledAt, completedAt, emailEvents = [] }) => {
  const [expandedNodes, setExpandedNodes] = useState(() => {
    const autoExpand = new Set();
    (history || []).forEach(entry => { if (entry['nodeType'] === 'voice') autoExpand.add(entry['nodeId']); });
    return autoExpand;
  });
  const toggleExpand = useCallback((nodeId) => {
    setExpandedNodes(prev => {
      const next = new Set(prev);
      if (next.has(nodeId)) next.delete(nodeId); else next.add(nodeId);
      return next;
    });
  }, []);

  const timelineItems = useMemo(() => {
    const orderedNodes = buildOrderedNodeList(sequenceNodes, sequenceEdges, entryNodeId);
    if (orderedNodes.length === 0) return [];
    const historyMap = {};
    (history || []).forEach(entry => {
      if (!historyMap[entry['nodeId']]) historyMap[entry['nodeId']] = [];
      historyMap[entry['nodeId']].push(entry);
    });
    const isWaitingOnDelay = nextProcessAt && new Date(nextProcessAt) > new Date() && contactStatus === 'active';

    return orderedNodes.map((node, index) => {
      const historyEntries = historyMap[node['id']] || [];
      const latestEntry = historyEntries.length > 0 ? historyEntries[historyEntries.length - 1] : null;
      let timelineStatus;

      const isDelayStillWaiting = node['type'] === 'delay' && latestEntry?.['status'] === 'success' &&
        node['id'] !== currentNodeId && !historyMap[currentNodeId]?.length && contactStatus === 'active';

      if (isDelayStillWaiting) {
        timelineStatus = 'current-waiting';
      } else if (latestEntry) {
        if (latestEntry['status'] === 'success') timelineStatus = 'completed';
        else if (latestEntry['status'] === 'failed') timelineStatus = 'failed';
        else if (latestEntry['status'] === 'skipped') timelineStatus = 'skipped';
        else if (latestEntry['status'] === 'processing') timelineStatus = 'current-active';
        else timelineStatus = 'completed';
      } else if (node['id'] === currentNodeId) {
        if (node['type'] === 'delay') {
          timelineStatus = 'current-waiting';
        } else {
          timelineStatus = isWaitingOnDelay && !historyMap[node['id']]?.length ? 'upcoming' : 'current-waiting';
        }
      } else {
        timelineStatus = 'upcoming';
      }

      let delayTargetDate = null;
      const isCurrentDelay = node['type'] === 'delay' && (isDelayStillWaiting || timelineStatus === 'current-waiting');
      if (isCurrentDelay && node['config']) {
        const delayStart = latestEntry?.['startedAt'] || latestEntry?.['completedAt'];
        if (delayStart) {
          delayTargetDate = new Date(new Date(delayStart).getTime() + getDelayMs(node['config'])).toISOString();
        } else {
          const prevNode = index > 0 ? orderedNodes[index - 1] : null;
          const prevEntries = prevNode ? historyMap[prevNode['id']] : null;
          const prevCompletion = prevEntries?.length > 0 ? prevEntries[prevEntries.length - 1]['completedAt'] : null;
          if (prevCompletion) {
            delayTargetDate = new Date(new Date(prevCompletion).getTime() + getDelayMs(node['config'])).toISOString();
          }
        }
      }

      const showCountdown = isCurrentDelay && !!delayTargetDate;
      return { node, index, historyEntry: latestEntry, timelineStatus, showCountdown, delayTargetDate, isLast: index === orderedNodes.length - 1 };
    });
  }, [sequenceNodes, sequenceEdges, entryNodeId, history, currentNodeId, nextProcessAt, contactStatus]);

  if ((!sequenceNodes || sequenceNodes.length === 0) && (!history || history.length === 0)) {
    return <Box sx={{ p: 3, textAlign: 'center' }}><Typography variant="body2" color="textSecondary">No execution timeline available</Typography></Box>;
  }

  return (
    <div className="execution-timeline-box">
      {/* Header */}
      <div className="header-timeline">
        <h4><TimelineIcon sx={{ fontSize: 16 }} /> Execution Timeline</h4>
        {enrolledAt && (
          <p>Enrolled {new Date(enrolledAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</p>
        )}
      </div>

      <div className="start-flow">
        <div className="node-start">
          <div className="icon">
            S
          </div>
          <h5>Start flow</h5>
        </div>
        <div className="divder-arrow">
          <svg width="9" height="32" viewBox="0 0 9 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.73" d="M5.08008 0.75C5.08008 0.335786 4.74429 2.47626e-08 4.33008 0C3.91586 -2.47626e-08 3.58008 0.335786 3.58008 0.75L4.33008 0.75L5.08008 0.75ZM4.33008 31.75L8.6602 24.25L-5.05191e-05 24.25L4.33008 31.75ZM4.33008 0.75L3.58008 0.75L3.58008 25L4.33008 25L5.08008 25L5.08008 0.75L4.33008 0.75Z" fill="#120348" />
          </svg>
        </div>
      </div>

      {/* Timeline Items */}
      <div className="timeline-area">
        {timelineItems.map((item) => {
          const { node, index, historyEntry, timelineStatus, showCountdown, delayTargetDate, isLast } = item;
          const style = getTimelineNodeStyle(timelineStatus, node['type']);
          const NodeIcon = nodeTypeIcons[node['type']] || TimelineIcon;
          const isExpanded = expandedNodes.has(node['id']);
          const isCurrent = timelineStatus === 'current-active' || timelineStatus === 'current-waiting';
          const isUpcoming = timelineStatus === 'upcoming';
          const isCompleted = timelineStatus === 'completed';
          const isDelayNode = node['type'] === 'delay';
          const stepNumber = index + 1;

          const duration = isDelayNode ? null : (historyEntry?.['startedAt'] && historyEntry?.['completedAt']
            ? Math.round((new Date(historyEntry['completedAt']) - new Date(historyEntry['startedAt'])) / 1000)
            : null);
          const delayLabel = isDelayNode && node['config']
            ? `${node['config']['duration'] || node['config']['days'] || 1} ${node['config']['unit'] || 'days'}`
            : null;
          const timeStr = isDelayNode ? null : (historyEntry?.['completedAt'] || historyEntry?.['startedAt']
            ? new Date(historyEntry['completedAt'] || historyEntry['startedAt']).toLocaleDateString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })
            : null);

          // Status chip label & color for right side
          const getStatusChip = () => {
            if (isDelayNode) {
              if (isCurrent) return { label: delayTargetDate && new Date(delayTargetDate) > new Date() ? 'In Progress' : 'Overdue', color: '#EF4D56', bg: '#FFFFFF', borderColor: '#EF4D56' };
              if (isCompleted) return { label: 'Done', color: '#16A34A', bg: '#F0FDF4' };
              return null;
            }
            if (isCurrent && !historyEntry) return { label: 'Current', color: '#120348', bg: '#12034813' };
            if (isUpcoming) return { label: 'Upcoming', color: '#F7931A', bg: '#F7931A13' };
            // Voice steps show the real call outcome from the populated CallLog (single source of truth), not the dispatch-time step status
            if (historyEntry && historyEntry['nodeType'] === 'voice' && historyEntry['status'] === 'success') {
              const callLog = historyEntry['activityId']?.['callLogId'];
              if (callLog?.['status'] === 'ongoing') return { label: 'Calling…', color: '#2563EB', bg: '#EFF6FF' };
              if (callLog?.['status'] === 'ended') return { label: 'Answered', color: '#16A34A', bg: '#F0FDF4' };
              if (callLog?.['endReason'] === 'Call Rejected') return { label: 'Failed', color: '#DC2626', bg: '#FEF2F2' };
              if (callLog) return { label: 'No Answer', color: '#6B7280', bg: '#F3F4F6' };
            }
            if (historyEntry) return { label: (execStatusConfig[historyEntry['status']] || {})['label'] || historyEntry['status'], color: (execStatusConfig[historyEntry['status']] || {})['color'] || '#6B7280', bg: (execStatusConfig[historyEntry['status']] || {})['bg'] || '#F3F4F6' };
            return null;
          };
          const statusChip = getStatusChip();

          return (
            <>
              <div key={node['id']} className={`timeline-item ${isCurrent ? 'active' : ''} ${isDelayNode ? 'delay' : ''} ${isCompleted ? 'completed' : ''}`}>
                {/* Node Card */}
                <div
                  className="node-card"
                  onClick={() => historyEntry && !isDelayNode && toggleExpand(node['id'])}
                  onMouseEnter={e => { if (historyEntry) e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0)'; }}
                  onMouseLeave={e => { e.currentTarget.style.boxShadow = 'none'; }}
                >
                  {/* Card Header Row */}
                  <div className="header-node">
                    {/* Step Number Badge */}
                    <div className="step-number">
                      #{stepNumber}
                    </div>
                    <div className="content-area">
                      <div className="left-text-area">
                        {/* Node Name */}
                        <h5>
                          <NodeIcon sx={{ fontSize: 14, color: style.iconColor }} />
                          {node['name'] || 'Unnamed Step'}
                        </h5>
                        {timeStr && (
                          <span style={{ color: '#9CA3AF', fontSize: 10 }}>{timeStr}</span>
                        )}
                        {/* Upcoming email subject preview */}
                        {isUpcoming && node['type'] === 'email' && node['config']?.['subject'] && (
                          <span style={{ color: '#9CA3AF', fontSize: 10 }}>
                            Will send: "{node['config']['subject']}"
                          </span>
                        )}
                        {delayLabel && (
                          <span style={{ color: '#6B7280', fontSize: 10 }}>{delayLabel}</span>
                        )}
                        {/* AI / Confidence chips row */}
                        {historyEntry && (historyEntry['isAIMode'] || historyEntry['confidenceScore'] > 0) && (
                          <div style={{ display: 'flex', gap: 4, }}>
                            {historyEntry['isAIMode'] && (
                              <span style={{
                                display: 'inline-flex', alignItems: 'center', gap: 3,
                                fontSize: 10, height: 18, borderRadius: 25,
                                background: '#E5EAFE', color: '#4B5563',
                                padding: '0 7px',
                              }}>
                                <AIIcon sx={{ fontSize: 11 }} /> AI Completed
                              </span>
                            )}
                            {historyEntry['confidenceScore'] > 0 && (
                              <span style={{
                                display: 'inline-flex', alignItems: 'center',
                                fontSize: 10, height: 18, borderRadius: 4,
                                background: historyEntry['confidenceScore'] >= 70 ? '#F0FDF4' : '#FFFBEB',
                                color: historyEntry['confidenceScore'] >= 70 ? '#16A34A' : '#D97706',
                                padding: '0 7px',
                              }}>
                                {Math.round(historyEntry['confidenceScore'])}% confidence
                              </span>
                            )}
                          </div>
                        )}

                        {/* Executes Date */}
                        {isDelayNode && showCountdown && delayTargetDate && (
                          <p style={{ color: '#6B7280', fontSize: 10 }}>
                            Executes: {new Date(delayTargetDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}
                          </p>
                        )}
                      </div>
                      <div className="right-area">

                        {statusChip && (
                          <span style={{
                            background: statusChip.bg,
                            color: statusChip.color,
                            fontWeight: 600,
                            fontSize: 8,
                            height: 20,
                            borderRadius: 4,
                            padding: '2px 7px',
                            display: 'inline-flex',
                            alignItems: 'center',
                            borderRadius: '25px',
                            border: '1px solid'
                          }}>
                            {statusChip.label}
                          </span>
                        )}
                        {historyEntry && !isDelayNode && (
                          <span style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', padding: 2 }}>
                            {isExpanded
                              ? <CollapseIcon sx={{ fontSize: 14 }} />
                              : <ExpandIcon sx={{ fontSize: 14 }} />
                            }
                          </span>
                        )}
                        {/* Countdown Timer for delay nodes */}
                        {isDelayNode && showCountdown && (
                          <CountdownTimer targetDate={delayTargetDate} />
                        )}
                      </div>
                    </div>
                  </div>
                  {/* <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px' }}> */}

                  {/* <div style={{
                    width: 22, height: 22, borderRadius: '50%',
                    background: isCompleted ? '#16A34A' : isCurrent ? style.borderColor : '#E5E7EB',
                    color: isCompleted || isCurrent ? '#fff' : '#9CA3AF',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 10, fontWeight: 700, flexShrink: 0,
                  }}>

                  </div> */}

                  {/* Node Icon */}
                  {/* <div style={{
                    width: 28, height: 28, borderRadius: 6,
                    background: `${style.iconColor}15`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    flexShrink: 0,
                  }}>
                    
                  </div> */}


                  {/* <span style={{
                    flex: 1,
                    color: isUpcoming ? '#9CA3AF' : '#111827',
                    fontSize: 13,
                    fontWeight: 600,
                  }}>
                    
                  </span> */}

                  {/* Right side: delay label + time + status chip + expand */}
                  {/* <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0 }}>

                  </div>
                </div> */}

                  {/* Expanded Step Preview */}
                  <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                    <div style={{ padding: '10px 12px 12px', borderTop: '1px solid #F3F4F6' }}>
                      {!historyEntry && <p style={{ fontSize: 12, color: '#9CA3AF', margin: 0 }}>No activity yet for this step.</p>}
                      {/* Email preview — from activityId if available, fallback to emailPreview for old records */}
                      {historyEntry?.['nodeType'] === 'email' && historyEntry['activityId']?.['description'] && (
                        <div className="detail-box">
                          {historyEntry['activityId']['emailSubject'] && (
                            <p style={{ margin: '0 0 4px', fontSize: 12 }}>Subject: {historyEntry['activityId']['emailSubject']}</p>
                          )}
                          <div style={{ fontSize: 11, color: '#6B7280', maxHeight: 140, overflow: 'auto', lineHeight: 1.6, marginBottom: 15, paddingBottom: 10, borderBottom: '1px solid #000000' }} dangerouslySetInnerHTML={{ __html: sanitizeEmailHtml(historyEntry['activityId']['description']) }} />
                        </div>
                      )}
                      {historyEntry?.['nodeType'] === 'email' && !historyEntry['activityId'] && historyEntry?.['emailPreview'] && (historyEntry['emailPreview']['subject'] || historyEntry['emailPreview']['body']) && (
                        <div className="detail-box">
                          {historyEntry['emailPreview']['subject'] && (
                            <p style={{ margin: '0 0 4px', fontSize: 12, }}>
                              Subject: {historyEntry['emailPreview']['subject']}
                            </p>
                          )}
                          {historyEntry['emailPreview']['body'] && (
                            <div
                              style={{ fontSize: 11, color: '#6B7280', maxHeight: 140, overflow: 'auto', lineHeight: 1.6, marginBottom: 15, paddingBottom: 10, borderBottom: '1px solid #000000' }}
                              dangerouslySetInnerHTML={{ __html: sanitizeEmailHtml(historyEntry['emailPreview']['body']) }}
                            />
                          )}
                        </div>
                      )}
                      {/* LinkedIn message preview */}
                      {historyEntry?.['nodeType'] === 'linkedin' && historyEntry['activityId']?.['description'] && (
                        <div className="detail-box timeline-linkedin-preview">
                          <p className="timeline-preview-label">LinkedIn Message</p>
                          <p className="timeline-preview-body">{historyEntry['activityId']['description']}</p>
                        </div>
                      )}
                      {/* SMS preview */}
                      {historyEntry?.['nodeType'] === 'sms' && historyEntry['activityId'] && (
                        <div className="detail-box timeline-sms-preview">
                          <p className="timeline-preview-label">SMS Message</p>
                          {historyEntry['activityId']['description'] && (
                            <p className="timeline-preview-body">{historyEntry['activityId']['description'].replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&nbsp;/g, ' ').replace(/<[^>]+>/g, '')}</p>
                          )}
                          <div className="timeline-sms-meta">
                            {historyEntry['activityId']['metadata']?.['from'] && (
                              <span className="timeline-sms-meta-item"><span className="timeline-sms-meta-label">From</span>{historyEntry['activityId']['metadata']['from']}</span>
                            )}
                            {historyEntry['activityId']['phoneNumber'] && (
                              <span className="timeline-sms-meta-item"><span className="timeline-sms-meta-label">To</span>{historyEntry['activityId']['phoneNumber']}</span>
                            )}
                            {historyEntry['completedAt'] && (
                              <span className="timeline-sms-meta-item"><span className="timeline-sms-meta-label">Sent</span>{new Date(historyEntry['completedAt']).toLocaleDateString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}</span>
                            )}
                            <span className="timeline-sms-meta-item"><span className="timeline-sms-meta-label">Status</span><span className="timeline-sms-status-sent">Sent</span></span>
                          </div>
                        </div>
                      )}
                      {/* Voice call preview */}
                      {historyEntry?.['nodeType'] === 'voice' && historyEntry['activityId'] && (
                        <div className="detail-box timeline-voice-preview">
                          <p className="timeline-preview-label">Agent Call</p>
                          <div className="timeline-voice-meta-row">
                            {historyEntry['activityId']['callLogId']?.['sentiment'] && (
                              <div className="timeline-voice-meta-item">
                                <span className="timeline-voice-meta-label">Call Sentiment</span>
                                <span className={`timeline-voice-sentiment timeline-voice-sentiment-${historyEntry['activityId']['callLogId']['sentiment']}`}>
                                  {historyEntry['activityId']['callLogId']['sentiment']}
                                </span>
                              </div>
                            )}
                            {historyEntry['activityId']['callLogId']?.['callDuration'] > 0 && (
                              <div className="timeline-voice-meta-item">
                                <span className="timeline-voice-meta-label">Duration</span>
                                <span className="timeline-voice-duration">{formatCallDuration(historyEntry['activityId']['callLogId']['callDuration'])}</span>
                              </div>
                            )}
                            {CALL_RESULT_META[historyEntry['activityId']['callLogId']?.['successEvalution']] && (
                              <div className="timeline-voice-meta-item">
                                <span className="timeline-voice-meta-label">Result</span>
                                <span className={`timeline-voice-result timeline-voice-result-${historyEntry['activityId']['callLogId']['successEvalution']}`}>{CALL_RESULT_META[historyEntry['activityId']['callLogId']['successEvalution']]['label']}</span>
                              </div>
                            )}
                            {historyEntry['activityId']['callLogId']?.['cost'] != null && (
                              <div className="timeline-voice-meta-item">
                                <span className="timeline-voice-meta-label">Cost</span>
                                <span className="timeline-voice-duration">${Number(historyEntry['activityId']['callLogId']['cost'] || 0).toFixed(4)}</span>
                              </div>
                            )}
                            {historyEntry['activityId']['callLogId']?.['endReason'] && (
                              <div className="timeline-voice-meta-item">
                                <span className="timeline-voice-meta-label">End Reason</span>
                                <span className="timeline-voice-duration">{historyEntry['activityId']['callLogId']['endReason']}</span>
                              </div>
                            )}
                          </div>
                          {historyEntry['activityId']['callLogId']?.['recordingUrl'] && (
                            <div className="timeline-voice-audio-row">
                              {/* preload="metadata" fetches only the file header so the real duration shows immediately — "0:00 / 0:00" until pressing play read as a broken recording; only rendered inside the drawer, so no bulk S3 traffic */}
                              <audio controls preload="metadata" className="timeline-voice-audio" src={historyEntry['activityId']['callLogId']['recordingUrl']} />
                              <a href={historyEntry['activityId']['callLogId']['recordingUrl']} download title="Download Audio" className="timeline-voice-audio-download"><i className="fa fa-download" /></a>
                            </div>
                          )}
                          {historyEntry['activityId']['callLogId']?.['callTranscript'] && (
                            <div className="timeline-voice-transcript-wrap">
                              <span className="timeline-voice-meta-label">Transcript</span>
                              <p className="timeline-preview-body timeline-voice-transcript">{historyEntry['activityId']['callLogId']['callTranscript']}</p>
                            </div>
                          )}
                        </div>
                      )}
                      {historyEntry?.['error'] && (
                        <div style={{ padding: 8, background: '#FEF2F2', borderRadius: 4, border: '1px solid #FECACA' }}>
                          <span style={{ color: '#DC2626', fontSize: 11 }}>
                            {historyEntry['error']}{historyEntry['retryCount'] > 0 && ` (Retried ${historyEntry['retryCount']}x)`}
                          </span>
                        </div>
                      )}
                      {historyEntry?.['tokensUsed'] && historyEntry['tokensUsed']['total'] > 0 && (
                        <p style={{ margin: 0, fontSize: 11, color: '#9CA3AF' }}>
                          Tokens: {historyEntry['tokensUsed']['total']} (P: {historyEntry['tokensUsed']['prompt']} / C: {historyEntry['tokensUsed']['completion']})
                        </p>
                      )}
                      {historyEntry?.['startedAt'] && (
                        <p style={{ margin: '4px 0 0', fontSize: 11, color: '#9CA3AF' }}>
                          {/* Voice steps complete at dispatch, not call end — "Started → +2s" next to a longer call read as broken data, so label it for what it is */}
                          {historyEntry['nodeType'] === 'voice' ? 'Dispatched' : 'Started'}: {new Date(historyEntry['startedAt']).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' })}
                          {historyEntry['nodeType'] !== 'voice' && historyEntry['completedAt'] && ` → ${new Date(historyEntry['completedAt']).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' })}`}
                        </p>
                      )}
                    </div>
                  </Collapse>
                </div>

              </div>

              {/* Engagement event sub-timeline for email nodes */}
              {node['type'] === 'email' && (() => {
                const nodeEngagementEvents = emailEvents
                  .filter(e => e['nodeId'] === node['id'] && e['type'] !== 'sent')
                  .sort((a, b) => new Date(a['createdAt']) - new Date(b['createdAt']));
                if (nodeEngagementEvents.length === 0) return null;
                return (
                  <div className="engagement-event-strip">
                    <div className="engagement-event-heading">Engagement</div>
                    {nodeEngagementEvents.map((ev, i) => (
                      <div key={i} className={`engagement-event-row engagement-event-${ev['type']}`}>
                        <span className="engagement-event-accent" />
                        <span className="engagement-event-icon-wrap">{ENGAGEMENT_EVENT_ICONS[ev['type']]}</span>
                        <span className="engagement-event-body">
                          <span className="engagement-event-label">
                            {ENGAGEMENT_EVENT_LABELS[ev['type']] || ev['type']}
                            {ev['type'] === 'reply' && REPLY_RESULT_META[ev['result']] && (
                              <span className="engagement-event-result" style={{ color: REPLY_RESULT_META[ev['result']]['color'], background: REPLY_RESULT_META[ev['result']]['bg'] }}>{REPLY_RESULT_META[ev['result']]['label']}</span>
                            )}
                          </span>
                          {ev['type'] === 'click' && ev['url'] && (
                            <span className="engagement-event-url">{truncateEngagementUrl(ev['url'])}</span>
                          )}
                        </span>
                        <span className="engagement-event-time">
                          {new Date(ev['createdAt']).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}
                        </span>
                      </div>
                    ))}
                  </div>
                );
              })()}

              {/* Connector Line between nodes */}
              {!isLast && (
                <div className="divder-arrow">
                  <svg width="9" height="32" viewBox="0 0 9 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path opacity="0.73" d="M5.08008 0.75C5.08008 0.335786 4.74429 2.47626e-08 4.33008 0C3.91586 -2.47626e-08 3.58008 0.335786 3.58008 0.75L4.33008 0.75L5.08008 0.75ZM4.33008 31.75L8.6602 24.25L-5.05191e-05 24.25L4.33008 31.75ZM4.33008 0.75L3.58008 0.75L3.58008 25L4.33008 25L5.08008 25L5.08008 0.75L4.33008 0.75Z" fill="#120348" />
                  </svg>
                </div>
              )}
            </>
          );
        })}

        {/* Sequence Completed indicator */}
        {contactStatus === 'completed' && completedAt && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1.5, pl: 0.5 }}>
            <CheckCircleIcon sx={{ fontSize: 16, color: '#16A34A' }} />
            <Typography variant="caption" sx={{ color: '#16A34A', fontWeight: 500 }}>
              Sequence completed {new Date(completedAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}
            </Typography>
          </Box>
        )}
      </div>

      <div className="start-flow end-flow">
        <div className="divder-arrow">
          <svg width="9" height="32" viewBox="0 0 9 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.73" d="M5.08008 0.75C5.08008 0.335786 4.74429 2.47626e-08 4.33008 0C3.91586 -2.47626e-08 3.58008 0.335786 3.58008 0.75L4.33008 0.75L5.08008 0.75ZM4.33008 31.75L8.6602 24.25L-5.05191e-05 24.25L4.33008 31.75ZM4.33008 0.75L3.58008 0.75L3.58008 25L4.33008 25L5.08008 25L5.08008 0.75L4.33008 0.75Z" fill="#120348" />
          </svg>
        </div>
        <div className="node-start">
          <div className="icon">
            E
          </div>
          <h5>End Flow</h5>
        </div>
      </div>
    </div>
  );
};

// Readable call results written by post-call analysis into successEvalution (legacy pass/fail rows render no badge)
const CALL_RESULT_META = {
  meeting_booked: { label: 'Meeting Booked', color: '#15803D', bg: 'rgba(34,197,94,.18)' },
  interested: { label: 'Interested', color: '#16a34a', bg: 'rgba(34,197,94,.1)' },
  callback: { label: 'Callback', color: '#B45309', bg: 'rgba(247,147,26,.12)' },
  not_interested: { label: 'Not Interested', color: '#DC2626', bg: '#FEF2F2' },
  do_not_call: { label: 'Do Not Call', color: '#991B1B', bg: '#FEE2E2' },
  wrong_number: { label: 'Wrong Number', color: '#6B7280', bg: '#F3F4F6' },
  voicemail: { label: 'Voicemail', color: '#6B7280', bg: '#F3F4F6' },
  no_conversation: { label: 'No Conversation', color: '#6B7280', bg: '#F3F4F6' },
  other: { label: 'Other', color: '#6B7280', bg: '#F3F4F6' }
};

// AI-classified reply intent shown next to "Replied" on the engagement row (emailEvents[].result)
const REPLY_RESULT_META = {
  interested: { label: 'Interested', color: '#16a34a', bg: 'rgba(34,197,94,.1)' },
  not_interested: { label: 'Not Interested', color: '#DC2626', bg: '#FEF2F2' },
  follow_up_later: { label: 'Follow Up Later', color: '#B45309', bg: 'rgba(247,147,26,.12)' },
  unsubscribe: { label: 'Unsubscribe', color: '#991B1B', bg: '#FEE2E2' },
  other: { label: 'Other', color: '#6B7280', bg: '#F3F4F6' }
};

const ENGAGEMENT_EVENT_LABELS = { open: 'Opened', click: 'Link Clicked', reply: 'Replied', unsubscribe: 'Unsubscribed', bounce: 'Bounced' };
const ENGAGEMENT_EVENT_ICONS = {
  open: <MarkEmailReadIcon sx={{ fontSize: 12 }} />,
  click: <LinkClickIcon sx={{ fontSize: 12 }} />,
  reply: <ReplyIcon sx={{ fontSize: 12 }} />,
  unsubscribe: <UnsubscribeIcon sx={{ fontSize: 12 }} />,
  bounce: <ErrorOutlineIcon sx={{ fontSize: 12 }} />,
};
const truncateEngagementUrl = (url) => {
  try {
    const { hostname, pathname } = new URL(url);
    const firstSegment = pathname.split('/').filter(Boolean)[0] || '';
    const short = firstSegment ? `${hostname}/${firstSegment}` : hostname;
    return short.length > 32 ? short.slice(0, 32) + '…' : short;
  } catch { return url.slice(0, 32); }
};

// ✅ Define OUTSIDE CampaignAnalytics, at the top level of the file
const ActivityFeedTab = ({ activityFeed, activityFeedLoading, nodeTypeIcons, nodeTypeColors }) => {
  const [activitySearch, setActivitySearch] = useState('');
  const [activityFilterOpen, setActivityFilterOpen] = useState(false);
  const [selectedActivityTypes, setSelectedActivityTypes] = useState([]);
  const activityFilterRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (activityFilterRef.current && !activityFilterRef.current.contains(e.target)) {
        setActivityFilterOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const activityTypeOptions = [
    { key: 'email', label: 'Email Send', color: '#120348', icon: EmailIcon },
    { key: 'opened', label: 'Email Opened', color: '#F7931A', icon: EmailIcon },
    { key: 'clicked', label: 'Link Clicked', color: '#EF4D56', icon: TimelineIcon },
    { key: 'reply', label: 'Reply', color: '#34A853', icon: TrendingUpIcon },
    { key: 'auto', label: 'Auto Reply', color: '#7C3AED', icon: AIIcon },
  ];

  const toggleActivityType = (key) => {
    setSelectedActivityTypes(prev =>
      prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]
    );
  };

  const filteredFeed = (activityFeed || []).filter(a => {
    const emailMatch = activitySearch
      ? (a['contactEmail'] || '').toLowerCase().includes(activitySearch.toLowerCase())
      : true;
    return emailMatch;
  });

  return (
    <div className="activity-table-anyltics">
      {/* Search + Filter Bar */}
      <div className="activity-header-anyltics">
        <Box sx={{
          display: 'flex', alignItems: 'center', gap: 1,
          flex: 1, border: '1px solid #E5E7EB', borderRadius: 2,
          px: 1.5, py: 0.75, bgcolor: '#fff'
        }}>
          <svg width="14" height="14" viewBox="0 0 20 20" fill="none">
            <path d="M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16zM19 19l-4.35-4.35" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" />
          </svg>
          <input
            type="text"
            placeholder="Search by email..."
            value={activitySearch}
            onChange={e => setActivitySearch(e.target.value)}
            style={{
              border: 'none', outline: 'none',
              background: 'transparent',
              fontFamily: 'inherit', flex: 1, minWidth: 0
            }}
          />
        </Box>
        <div ref={activityFilterRef} style={{ position: 'relative' }}>
          <button
            onClick={() => setActivityFilterOpen(p => !p)}
            style={{
              borderRadius: 8, background: '#fff',
              width: 31, height: 31, display: 'flex', alignItems: 'center',
              justifyContent: 'center', cursor: 'pointer',
              color: selectedActivityTypes.length > 0 ? '#120348' : '#6B7280'
            }}
          >
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.38161 13.2126C6.10161 13.2126 5.82744 13.1426 5.57078 13.0026C5.05744 12.7168 4.74828 12.1976 4.74828 11.6143V8.5226C4.74828 8.23093 4.55578 7.79343 4.37494 7.57176L2.19328 5.26176C1.82578 4.89426 1.54578 4.26426 1.54578 3.79176V2.4501C1.54578 1.51676 2.25161 0.787598 3.14994 0.787598H10.8499C11.7366 0.787598 12.4541 1.5051 12.4541 2.39176V3.6751C12.4541 4.2876 12.0866 4.98176 11.7424 5.32593L9.21661 7.5601C8.97161 7.76426 8.77911 8.21343 8.77911 8.5751V11.0834C8.77911 11.6026 8.45244 12.2034 8.04411 12.4484L7.23911 12.9676C6.97661 13.1309 6.67911 13.2126 6.38161 13.2126ZM3.14994 1.6626C2.74161 1.6626 2.42078 2.00676 2.42078 2.4501V3.79176C2.42078 4.0076 2.59578 4.4276 2.81744 4.64926L5.03994 6.98843C5.33744 7.35593 5.62911 7.96843 5.62911 8.51676V11.6084C5.62911 11.9876 5.89161 12.1743 6.00244 12.2326C6.24744 12.3668 6.54494 12.3668 6.77244 12.2268L7.58328 11.7076C7.74661 11.6084 7.90994 11.2934 7.90994 11.0834V8.5751C7.90994 7.95093 8.21328 7.2626 8.65078 6.8951L11.1474 4.68426C11.3458 4.48593 11.5849 4.01343 11.5849 3.66926V2.39176C11.5849 1.98926 11.2583 1.6626 10.8558 1.6626H3.14994Z" fill="#4B5563" />
              <path d="M3.49995 6.27107C3.41829 6.27107 3.34245 6.24774 3.26662 6.2069C3.06245 6.07857 2.99829 5.8044 3.12662 5.60023L6.00245 0.991902C6.13079 0.787735 6.39912 0.723568 6.60329 0.851902C6.80745 0.980235 6.87162 1.24857 6.74329 1.45274L3.86745 6.06107C3.78579 6.19523 3.64579 6.27107 3.49995 6.27107Z" fill="#4B5563" />
            </svg>
          </button>

          {activityFilterOpen && (
            <div style={{
              position: 'absolute', top: 'calc(100% + 6px)', right: 0,
              width: 200, background: '#fff', border: '1px solid #E5E7EB',
              borderRadius: 10, boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
              zIndex: 1000, overflow: 'hidden'
            }}>
              {activityTypeOptions.map(opt => (
                <div
                  key={opt.key}
                  onClick={() => toggleActivityType(opt.key)}
                  style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '9px 14px', cursor: 'pointer', fontSize: 13, color: '#111827' }}
                  onMouseEnter={e => e.currentTarget.style.background = '#F9FAFB'}
                  onMouseLeave={e => e.currentTarget.style.background = '#fff'}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <opt.icon sx={{ fontSize: 15, color: opt.color }} />
                    <span>{opt.label}</span>
                  </Box>
                  {selectedActivityTypes.includes(opt.key) && (
                    <svg width="12" height="9" viewBox="0 0 12 9" fill="none">
                      <path d="M1 4.5L4.5 8L11 1" stroke="#22C55E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Table */}
      <TableContainer sx={{ maxHeight: 420 }}>
        {activityFeedLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}><CircularProgress size={24} sx={{ color: 'var(--primary-color)' }} /></Box>
        ) : filteredFeed.length === 0 ? (
          <Box sx={{ p: 4, textAlign: 'center' }}><Typography variant="body2" color="textSecondary">No activity yet</Typography></Box>
        ) : (
          <Table size="small">
            <TableBody>
              {filteredFeed.map((activity, idx) => {
                const AIcon = nodeTypeIcons[activity['nodeType']] || TimelineIcon;
                const aColor = nodeTypeColors[activity['nodeType']] || '#6B7280';
                const statusLabel = activity['status'] === 'success' ? 'Send'
                  : activity['status'] === 'failed' ? 'Failed'
                    : activity['status'];
                const completedDate = activity['completedAt'] ? new Date(activity['completedAt']) : null;
                const dateStr = completedDate
                  ? completedDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
                  + ', ' + completedDate.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })
                  : '—';

                return (
                  <TableRow key={idx}>
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box sx={{ width: 30, height: 30, borderRadius: '50%', bgcolor: aColor + '18', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                          <AIcon sx={{ fontSize: 15, color: aColor }} />
                        </Box>
                        <Box>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <Typography variant="body2" fontWeight={600} sx={{ fontSize: '13px', color: '#111827' }}>{statusLabel}</Typography>
                            {activity['isAIMode'] && <Chip label="AI" size="small" sx={{ fontSize: 9, height: 16, bgcolor: '#fbfbff', color: '#120348' }} />}
                          </Box>
                          <Typography variant="caption" sx={{ color: '#9CA3AF', fontSize: '11px' }} noWrap>
                            {activity['fromEmail'] || activity['senderEmail'] || activity['mailboxEmail'] || '—'}
                          </Typography>
                        </Box>
                      </Box>
                    </TableCell>

                    <TableCell>
                      <Typography variant="body2" sx={{ color: '#374151', fontSize: '13px' }}>{activity['contactEmail'] || '—'}</Typography>
                    </TableCell>

                    <TableCell sx={{ whiteSpace: 'nowrap' }}>
                      <Typography variant="caption" sx={{ color: '#6B7280', fontSize: '12px' }}>{dateStr}</Typography>
                      {activity['delayLabel'] && (
                        <Typography variant="caption" sx={{ color: '#9CA3AF', display: 'block', fontSize: '11px' }}>Wait {activity['delayLabel']}</Typography>
                      )}
                    </TableCell>

                    <TableCell sx={{ textAlign: 'right' }}>
                      <Typography variant="caption" sx={{ color: '#6B7280', fontSize: '12px', bgcolor: '#F3F4F6', px: 1, py: 0.4, borderRadius: 1 }}>{activity['nodeName'] || '—'}</Typography>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        )}
      </TableContainer>
    </div>
  );
};



const CampaignAnalytics = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const routerHistory = useHistory();
  const { search: locationSearch } = useLocation();
  const contactsFetchKeyRef = useRef('');
  const activityFetchedRef = useRef(false);
  const [activeTab, setActiveTab] = useState(() => { const p = new URLSearchParams(locationSearch); return p.get('tab') === 'contacts' ? 1 : 0; });
  const [overviewSubTab, setOverviewSubTab] = useState(0);
  const [mailboxTesting, setMailboxTesting] = useState({});
  const [expandedFailRow, setExpandedFailRow] = useState(null);
  const [dateRange, setDateRange] = useState({ preset: 'all_time', start: null, end: null });
  const [selectedPreset, setSelectedPreset] = useState('all_time');
  const [customRange, setCustomRange] = useState([null, null]);
  const [showDateDropdown, setShowDateDropdown] = useState(false);
  const [showCustomPicker, setShowCustomPicker] = useState(false);
  const dateDropdownRef = useRef(null);
  const [contactPage, setContactPage] = useState(0);
  const [contactLimit, setContactLimit] = useState(20);
  const [selectedContact, setSelectedContact] = useState(null);
  const [metricsDropdownOpen, setMetricsDropdownOpen] = useState(false);
  const [metricsSearch, setMetricsSearch] = useState('');
  const metricsDropdownRef = useRef(null);
  const [contactSearch, setContactSearch] = useState('');
  const [contactStatusFilter, setContactStatusFilter] = useState([]);
  const [exportingContacts, setExportingContacts] = useState(false);
  const [showAdvancedFilter, setShowAdvancedFilter] = useState(false);
  const [activeContactFilters, setActiveContactFilters] = useState({});
  const [selectedOwner, setSelectedOwner] = useState('All User');
  const [ownerDropdownOpen, setOwnerDropdownOpen] = useState(false);
  const [ownerSearch, setOwnerSearch] = useState('');
  const [editingName, setEditingName] = useState(false);
  const [auditLogOpen, setAuditLogOpen] = useState(false);

  const { currentWorkspace } = useSelector(state => state['Settings']);
  const { singleCampaign, singleCampaignLoading, analytics, analyticsLoading, campaignContacts, campaignContactsLoading, campaignContactsTotal, campaignContactsStats, activityFeed, activityFeedLoading, auditLog, auditLogLoading } = useSelector(state => state['Campaign']);
  const { salesAccounts } = useSelector(state => state['Integration']);
  const { allPhones } = useSelector(state => state['Phone'] || {});
  useEffect(() => {
    if (id) {
      dispatch(getSingleCampaign(id));
      dispatch(getCampaignAnalytics(resolveDatePayload(id, dateRange)));
      dispatch(getSalesAccounts());
      dispatch(getAllPhones());
    }
  }, [dispatch, id]);

  const isDateRangeMounted = useRef(false);
  useEffect(() => {
    if (!isDateRangeMounted.current) { isDateRangeMounted.current = true; return; }
    if (id) dispatch(getCampaignAnalytics(resolveDatePayload(id, dateRange)));
  }, [dispatch, id, dateRange]);

  const senderEmails = useMemo(() => {
    const emails = new Set();
    const accountIntegrations = singleCampaign?.['accountIntegrations'] || {};
    const salesAccountsData = salesAccounts?.['data'] || [];
    Object.keys(accountIntegrations).forEach(accountId => {
      const account = salesAccountsData.find(a => a['_id'] === accountId);
      if (!account) return;
      const selectedIds = accountIntegrations[accountId] || [];
      (account['integrations'] || []).forEach(i => {
        if (!selectedIds.includes(i['_id'])) return;
        const toolName = (i['toolId']?.['name'] || i['name'] || '').toLowerCase();
        if (toolName !== 'gmail' && toolName !== 'outlook') return;
        const email = i['accountIdentifier'] || i['tokens']?.['email'] || '';
        if (email) emails.add(email);
      });
    });
    return [...emails];
  }, [singleCampaign, salesAccounts]);

  const filteredUsers = senderEmails.filter(email =>
    email.toLowerCase().includes(ownerSearch.toLowerCase())
  );

  const getInitial = (email) => email?.[0]?.toUpperCase() || '?';

  const avatarColors = ['#0d9488', '#7c3aed', '#dc2626', '#ea580c', '#2563eb'];
  const getColor = (email) => avatarColors[email?.charCodeAt(0) % avatarColors.length];

  const filteredContacts = useMemo(() => {
    let list = campaignContacts || [];
    if (contactSearch.trim()) {
      const q = contactSearch.toLowerCase();
      list = list.filter(cc => {
        const contact = cc.contactId || {};
        const name = [contact.firstName, contact.lastName].filter(Boolean).join(' ').toLowerCase();
        const email = (contact.email || '').toLowerCase();
        const company = (contact.company || '').toLowerCase();
        return name.includes(q) || email.includes(q) || company.includes(q);
      });
    }
    // Status/event and owner filtering is handled server-side — no client-side re-filter needed
    return list;
  }, [campaignContacts, contactSearch]);

  useEffect(() => {
    if (id && activeTab === 1) {
      const filtersKey = JSON.stringify(activeContactFilters?.query || {});
      const ownerKey = selectedOwner !== 'All User' ? selectedOwner : '';
      const key = `${id}-${contactPage}-${contactLimit}-${filtersKey}-${contactSearch}-${contactStatusFilter.join(',')}-${ownerKey}`;
      if (contactsFetchKeyRef.current === key) return;
      contactsFetchKeyRef.current = key;
      dispatch(getCampaignContacts({
        id,
        page: contactPage + 1,
        limit: contactLimit,
        filters: Object.keys(activeContactFilters?.query || {}).length ? activeContactFilters.query : undefined,
        search: contactSearch || undefined,
        status: contactStatusFilter.length ? contactStatusFilter.join(',') : undefined,
        owner: selectedOwner !== 'All User' ? selectedOwner : undefined,
      }));
    }
  }, [dispatch, id, activeTab, contactPage, contactLimit, activeContactFilters, contactSearch, contactStatusFilter, selectedOwner]);

  useEffect(() => {
    const p = new URLSearchParams(routerHistory.location.search);
    const newTab = activeTab === 1 ? 'contacts' : 'overview';
    if (p.get('tab') === newTab) return;
    p.set('tab', newTab);
    routerHistory.replace({ search: p.toString() });
  }, [activeTab]);

  useEffect(() => {
    const p = new URLSearchParams(routerHistory.location.search);
    if (selectedContact) {
      p.set('contact', selectedContact['_id']);
    } else {
      p.delete('contact');
    }
    routerHistory.replace({ search: p.toString() });
  }, [selectedContact]);

  useEffect(() => {
    if (!campaignContacts || campaignContacts.length === 0) return;
    const p = new URLSearchParams(routerHistory.location.search);
    const contactId = p.get('contact');
    if (!contactId || selectedContact) return;
    const match = campaignContacts.find(c => c['_id'] === contactId || c['contactId']?.['_id'] === contactId);
    if (match) setSelectedContact(match);
  }, [campaignContacts]);

  const handleAdvancedFilterApply = ({ filters, filterDefinition }) => {
    setActiveContactFilters({ query: filters || {}, definition: filterDefinition });
    setContactPage(0);
    contactsFetchKeyRef.current = '';
  };

  const handleRemoveContactFilter = (groupId, filterId) => {
    const updatedGroups = (activeContactFilters?.definition?.filterGroups || []).map(group =>
      group['id'] === groupId ? { ...group, filters: group['filters'].filter(f => f['id'] !== filterId) } : group
    ).filter(group => group['filters'].length > 0);
    const updatedDefinition = { ...(activeContactFilters?.definition || {}), filterGroups: updatedGroups };
    const mongoQuery = updatedGroups.length ? buildMongoQuery(updatedGroups, updatedDefinition['groupOperator']) : {};
    setActiveContactFilters({ query: mongoQuery, definition: updatedDefinition });
    setContactPage(0);
    contactsFetchKeyRef.current = '';
  };

  // Download the currently filtered contacts as a CSV built server-side from the same filters,
  // limited to the fields picked in the Export CSV dropdown
  const handleExportContacts = async (selectedFields) => {
    if (exportingContacts) return;
    setExportingContacts(true);
    try {
      const params = new URLSearchParams();
      if (selectedFields?.length) params.append('fields', selectedFields.join(','));
      if (Object.keys(activeContactFilters?.query || {}).length) params.append('filters', JSON.stringify(activeContactFilters['query']));
      if (contactStatusFilter.length) params.append('status', contactStatusFilter.join(','));
      if (selectedOwner !== 'All User') params.append('owner', selectedOwner);
      if (contactSearch.trim()) params.append('search', contactSearch.trim());
      const response = await axios.get(`${ApiUrl}/campaign/detail/${id}/contacts/export?${params.toString()}`);
      const { url, totalExported } = response['data']['body'] || response['data'];
      const a = document.createElement('a');
      a.href = url;
      a.setAttribute('download', '');
      a.click();
      toast.success(`Exported ${totalExported?.toLocaleString() || ''} contacts`);
    } catch (error) {
      console.error('Export contacts error:', error);
      toast.error('Failed to export contacts');
    } finally { setExportingContacts(false); }
  };

  const handleClearContactFilters = () => {
    setActiveContactFilters({ query: {}, definition: { filterGroups: [], groupOperator: 'OR' } });
    setContactPage(0);
    contactsFetchKeyRef.current = '';
  };

  const handleSearchChange = (e) => {
    setContactSearch(e.target.value);
    setContactPage(0);
  };

  // Add/remove one status from the multi-select filter (used by the quick-filter pills)
  const toggleStatusFilter = (value) => {
    setContactStatusFilter(prev => prev.includes(value) ? prev.filter(v => v !== value) : [...prev, value]);
    setContactPage(0);
    contactsFetchKeyRef.current = '';
  };


  // Lazy load activity feed when Activity sub-tab is first clicked
  useEffect(() => {
    if (id && overviewSubTab === 1 && !activityFetchedRef.current) {
      activityFetchedRef.current = true;
      dispatch(getActivityFeed({ id, page: 1, limit: 50 }));
    }
  }, [dispatch, id, overviewSubTab]);

  // Load audit log when drawer opens
  const auditLogFetchedRef = useRef(false);
  useEffect(() => {
    if (id && auditLogOpen && !auditLogFetchedRef.current) {
      auditLogFetchedRef.current = true;
      dispatch(getCampaignAuditLog({ id, page: 1, limit: 50 }));
    }
  }, [dispatch, id, auditLogOpen]);

  const handlePresetSelect = (preset) => {
    setSelectedPreset(preset);
    if (preset !== 'custom') {
      setDateRange({ preset, start: null, end: null });
      setShowDateDropdown(false);
      setShowCustomPicker(false);
    } else {
      setShowCustomPicker(true);
    }
  };

  const handleCustomRangeChange = (update) => {
    setCustomRange(update);
    if (update[0] && update[1]) {
      setDateRange({ preset: 'custom', start: update[0], end: update[1] });
      setShowDateDropdown(false);
    }
  };

  const handleRefresh = () => {
    dispatch(getCampaignAnalytics(resolveDatePayload(id, dateRange)));
    if (activeTab === 1) {
      contactsFetchKeyRef.current = '';
      dispatch(getCampaignContacts({ id, page: contactPage + 1, limit: contactLimit, filters: Object.keys(activeContactFilters?.query || {}).length ? activeContactFilters.query : undefined }));
    }
    if (overviewSubTab === 1) {
      activityFetchedRef.current = false;
      dispatch(getActivityFeed({ id, page: 1, limit: 50 }));
    }
  };

  const [enabledMetrics, setEnabledMetrics] = useState({
    contactsReached: true,
    sequenceStarted: true,
    replyRate: true,
    openRate: true,
    opportunities: true,
    clickRate: false,
    bounceRate: false,
    positiveReplyRate: false,
    meetingsBooked: false,
    includeAutoReplies: false,
  });

  const toggleMetric = (key) => {
    setEnabledMetrics(prev => ({ ...prev, [key]: !prev[key] }));
  };

  useEffect(() => {
    const handler = (e) => {
      if (metricsDropdownRef.current && !metricsDropdownRef.current.contains(e.target)) {
        setMetricsDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  useEffect(() => {
    const handler = (e) => {
      if (dateDropdownRef.current && !dateDropdownRef.current.contains(e.target)) {
        setShowDateDropdown(false);
        setShowCustomPicker(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  // Use filteredMetrics when a date range is active, fall back to campaign-level metrics for "All time"
  const metrics = (dateRange?.['preset'] !== 'all_time' && analytics?.['filteredMetrics']) ? { ...(singleCampaign?.['metrics'] || {}), ...analytics['filteredMetrics'] } : (singleCampaign?.['metrics'] || {});
  // Filtered contacts fetches return their own stats (same keys as metrics/contactStats) — overlay them so chips and the status dropdown follow the active filters
  const campaignWideStats = analytics?.['contactStats'] || {};
  const contactStats = campaignContactsStats || campaignWideStats;
  const contactsTotal = Object.keys(statusConfig).reduce((a, k) => a + (contactStats[k] || 0), 0);
  const countMetrics = { ...metrics, ...contactStats };
  const integrationStats = analytics?.['integrationStats'] || { email: [], voice: [] };
  const unhealthyIntegrations = (integrationStats['email'] || []).filter(r => r['health'] === 'needs_reconnect').length;

  const selectedPhoneIds = singleCampaign?.['selectedPhoneIds'] || [];
  const voiceRows = useMemo(() => {
    const voiceActivity = integrationStats['voice'] || [];
    if (selectedPhoneIds.length > 0 && allPhones?.length) {
      const byPhoneId = Object.fromEntries(voiceActivity.map(r => [String(r['phoneId'] || ''), r]));
      return selectedPhoneIds.map(pid => {
        const rawId = pid?.['_id'] || pid;
        const phone = allPhones.find(p => String(p['_id']) === String(rawId));
        if (!phone) return null;
        const stats = byPhoneId[String(phone['_id'])] || {};
        const agentName = stats['agentName'] || phone['outboundAgentId']?.['name'] || '—';
        const agentId = stats['agentId'] || phone['outboundAgentId']?.['_id'] || null;
        return { agentName, agentId, phoneId: phone['_id'], salesAccountId: phone['salesAccountId'] || null, nickName: phone['nickName'] || '', phoneNumber: phone['phoneNumber'] || '—', attempted: stats['attempted'] || 0, sent: stats['sent'] || 0, failed: stats['failed'] || 0 };
      }).filter(Boolean);
    }
    // Raw activity rows carry agentId/phoneId from the server — enrich with the phone's sales account for deep links
    return voiceActivity.map(r => ({ ...r, salesAccountId: (allPhones || []).find(p => String(p['_id']) === String(r['phoneId'] || ''))?.['salesAccountId'] || null }));
  }, [selectedPhoneIds, allPhones, integrationStats]);

  // Open the call agent's detail page in a new tab
  const openAgentInNewTab = (agentId) => window.open(getWorkspacePath(`/agents/${agentId}`, currentWorkspace?.['_id']), '_blank');

  // Open the phone integration inside its sales account in a new tab (drawer restores from channel+integration params)
  const openPhoneIntegrationInNewTab = (row) => {
    const params = new URLSearchParams({ channel: 'voice', integration: String(row['phoneId']) });
    const salesAccountId = row['salesAccountId']?.['_id'] || row['salesAccountId'];
    if (salesAccountId) params.set('account', String(salesAccountId));
    window.open(getWorkspacePath(`/connections/sales-accounts?${params.toString()}`, currentWorkspace?.['_id']), '_blank');
  };

  // Test a mailbox's live SMTP connection, then refresh analytics so its status reflects the result
  const handleTestMailbox = (integrationId) => {
    if (!integrationId || mailboxTesting[integrationId]) return;
    setMailboxTesting(s => ({ ...s, [integrationId]: true }));
    const done = () => { setMailboxTesting(s => ({ ...s, [integrationId]: false })); dispatch(getCampaignAnalytics(resolveDatePayload(id, dateRange))); };
    dispatch(testSmtpConnection(integrationId, done, done));
  };

  // event-based filter counts come from contactStats (backend aggregation) — not computed from loaded page


  const totalSent = (metrics['emailsSent'] || 0) + (metrics['smsSent'] || 0) + (metrics['callsMade'] || 0) + (metrics['whatsappSent'] || 0) + (metrics['linkedinSent'] || 0);
  const totalReplies = (metrics['emailsReplied'] || 0) + (metrics['smsReplied'] || 0) + (metrics['callsAnswered'] || 0) + (metrics['whatsappReplied'] || 0) + (metrics['linkedinReplied'] || 0);
  const activeChannelCount = Object.values(channelConfig).filter(ch => (metrics[ch['sentKey']] || 0) > 0).length;
  const responseRate = (metrics['totalContacts'] || 0) > 0 ? Math.round((totalReplies / metrics['totalContacts']) * 100) : 0;
  const emailSent = metrics['emailsSent'] || 0;
  const emailOpened = metrics['emailsOpened'] || 0;
  const emailClicked = metrics['emailsClicked'] || 0;
  const openRate = emailSent > 0 ? Math.round((emailOpened / emailSent) * 100) : 0;
  const clickRate = emailSent > 0 ? Math.round((emailClicked / emailSent) * 100) : 0;

  // Determine which channels are active — prefer campaign.channels config, fall back to inferring from metrics
  const activeChannels = Object.entries(channelConfig).filter(([key, ch]) =>
    singleCampaign?.['channels']?.[key]?.['enabled'] || (metrics[ch['sentKey']] || 0) > 0
  ).map(([key, ch]) => ({ key, ...ch }));
  const isEmailCampaign = activeChannels.some(ch => ch.key === 'email');
  const isVoiceCampaign = activeChannels.some(ch => ch.key === 'voice');
  const isSMSCampaign = activeChannels.some(ch => ch.key === 'sms');
  const isLinkedInCampaign = activeChannels.some(ch => ch.key === 'linkedin');
  const isPureVoice = isVoiceCampaign && !isEmailCampaign && !isSMSCampaign && !isLinkedInCampaign;

  // Options for the contacts status multi-select — one dynamic source for both the menu items and the selected-value labels
  const contactStatusOptions = [
    ...Object.entries(statusConfig).filter(([k]) => contactStats[k] && k !== 'opted_out').map(([k, v]) => { const Icon = v['icon']; return { value: k, label: v['label'], count: contactStats[k] || 0, icon: <Icon sx={{ fontSize: 14, color: v['color'] }} /> }; }),
    isVoiceCampaign && (countMetrics['callsAnswered'] || 0) > 0 && { value: 'call_answered', label: 'Answered', count: countMetrics['callsAnswered'] || 0, icon: <CallsAnsweredIcon /> },
    isVoiceCampaign && (countMetrics['callsMade'] || 0) > (countMetrics['callsAnswered'] || 0) && { value: 'call_no_answer', label: 'No Answer', count: (countMetrics['callsMade'] || 0) - (countMetrics['callsAnswered'] || 0), icon: <PhoneIcon sx={{ fontSize: 14, color: '#6B7280' }} /> },
    isVoiceCampaign && (contactStats['call_positive'] || 0) > 0 && { value: 'call_positive', label: 'Positive', count: contactStats['call_positive'], icon: <CheckCircleIcon sx={{ fontSize: 14, color: '#16a34a' }} /> },
    isVoiceCampaign && (contactStats['call_negative'] || 0) > 0 && { value: 'call_negative', label: 'Negative', count: contactStats['call_negative'], icon: <ErrorIcon sx={{ fontSize: 14, color: '#DC2626' }} /> },
    // Dynamic call-result filters — every status present on this campaign's calls shows with its count
    ...(isVoiceCampaign ? Object.entries(CALL_RESULT_META).filter(([resultKey]) => resultKey !== 'voicemail').map(([resultKey, meta]) => (contactStats[`call_result_${resultKey}`] || 0) > 0 && { value: `call_result_${resultKey}`, label: meta['label'], count: contactStats[`call_result_${resultKey}`], icon: ['meeting_booked', 'interested'].includes(resultKey) ? <CheckCircleIcon sx={{ fontSize: 14, color: meta['color'] }} /> : <ErrorIcon sx={{ fontSize: 14, color: meta['color'] }} /> }) : []),
    isVoiceCampaign && (contactStats['call_voicemail'] || 0) > 0 && { value: 'call_voicemail', label: 'Voicemail', count: contactStats['call_voicemail'], icon: <PhoneIcon sx={{ fontSize: 14, color: '#6B7280' }} /> },
    isEmailCampaign && (contactStats['link_clicked'] || 0) > 0 && { value: 'link_clicked', label: 'Link Clicked', count: contactStats['link_clicked'], icon: <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.80936 6.24772C4.8676 6.24761 4.92529 6.25904 4.9791 6.28133C5.0329 6.30363 5.08176 6.33636 5.12285 6.37764C5.81435 7.06913 6.93949 7.06935 7.63121 6.37764C7.67211 6.33529 7.72104 6.30151 7.77514 6.27827C7.82924 6.25503 7.88742 6.2428 7.94629 6.24229C8.00517 6.24178 8.06356 6.253 8.11805 6.27529C8.17254 6.29759 8.22205 6.33051 8.26368 6.37214C8.30532 6.41378 8.33824 6.46328 8.36054 6.51778C8.38283 6.57227 8.39405 6.63066 8.39354 6.68953C8.39303 6.74841 8.38079 6.80659 8.35756 6.86069C8.33432 6.91479 8.30054 6.96371 8.25819 7.00462C7.22084 8.04219 5.533 8.04197 4.49587 7.00462C4.43388 6.94261 4.39167 6.86361 4.37456 6.77761C4.35746 6.69161 4.36624 6.60247 4.3998 6.52146C4.43335 6.44045 4.49017 6.3712 4.56307 6.32248C4.63597 6.27375 4.72168 6.24774 4.80936 6.24772Z" fill="#EF4D56" /><path d="M3.55527 4.36574C3.64295 4.36576 3.72866 4.39177 3.80156 4.4405C3.87446 4.48922 3.93128 4.55847 3.96483 4.63948C3.99838 4.72049 4.00716 4.80963 3.99006 4.89563C3.97296 4.98163 3.93075 5.06063 3.86875 5.12264L1.39188 7.59951C1.35098 7.64186 1.30205 7.67564 1.24795 7.69888C1.19385 7.72212 1.13567 7.73435 1.07679 7.73486C1.01792 7.73537 0.959531 7.72416 0.905038 7.70186C0.850545 7.67957 0.801038 7.64664 0.759405 7.60501C0.717772 7.56338 0.684848 7.51387 0.662553 7.45938C0.640258 7.40488 0.629039 7.34649 0.62955 7.28762C0.630062 7.22874 0.642294 7.17056 0.665532 7.11646C0.68877 7.06236 0.72255 7.01344 0.7649 6.97253L3.24178 4.49566C3.28287 4.45438 3.33173 4.42165 3.38553 4.39935C3.43934 4.37706 3.49702 4.36563 3.55527 4.36574Z" fill="#EF4D56" /></svg> },
    isEmailCampaign && (contactStats['reply_received'] || 0) > 0 && { value: 'reply_received', label: 'Reply Received', count: contactStats['reply_received'], icon: <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.00001 0C2.69161 0 0 2.69161 0 6.00001C0 9.30842 2.69161 12 6.00001 12C9.30842 12 12 9.30842 12 6.00001C12 2.69161 9.30842 0 6.00001 0ZM6.00001 10.9091C3.2931 10.9091 1.09091 8.70689 1.09091 6.00001C1.09091 3.29313 3.2931 1.09091 6.00001 1.09091C8.70693 1.09091 10.9091 3.29313 10.9091 6.00001C10.9091 8.70689 8.70689 10.9091 6.00001 10.9091Z" fill="#34A853" /><path d="M8.24979 3.87898L5.16418 6.96455L3.74999 5.55033C3.53701 5.33735 3.19163 5.33731 2.97861 5.5503C2.76559 5.76332 2.76559 6.10866 2.97861 6.32168L4.77847 8.12161C4.88075 8.22391 5.01948 8.28138 5.16414 8.28139H5.16418C5.30883 8.28139 5.44756 8.2239 5.54985 8.12165L9.02117 4.6504C9.23419 4.43739 9.23419 4.09204 9.02117 3.87902C8.80815 3.666 8.4628 3.66597 8.24979 3.87898Z" fill="#34A853" /></svg> },
    isEmailCampaign && (contactStats['email_opened'] || 0) > 0 && { value: 'email_opened', label: 'Email Opened', count: contactStats['email_opened'], icon: <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.88436 3.7037L5.66853 0.363367C5.53523 0.257699 5.37013 0.200195 5.20003 0.200195C5.02993 0.200195 4.86482 0.257699 4.73153 0.363367L0.516864 3.7037C0.417957 3.78139 0.33804 3.88058 0.283174 3.99375C0.228307 4.10692 0.19993 4.2311 0.200197 4.35686V9.20136C0.200462 9.4665 0.305904 9.7207 0.493383 9.90818C0.680862 10.0957 0.935062 10.2011 1.2002 10.2014H9.20019C9.46533 10.2011 9.71953 10.0957 9.90701 9.90818C10.0945 9.7207 10.1999 9.4665 10.2002 9.20136V4.35686C10.2006 4.23116 10.1723 4.10703 10.1176 3.99386C10.0629 3.8807 9.98311 3.78147 9.88436 3.7037Z" fill="#F7931A" stroke="#F7931A" strokeWidth="0.4" /></svg> },
    isEmailCampaign && (contactStats['bounced'] || 0) > 0 && { value: 'bounced', label: 'Bounced', count: contactStats['bounced'], icon: <svg width="11" height="11" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="#EF4D56" /></svg> },
    isEmailCampaign && (contactStats['no_email_opened'] || 0) > 0 && { value: 'no_email_opened', label: 'No Email Opened', count: contactStats['no_email_opened'], icon: <svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.04199 8.51855L4.50977 9.20703V8.3457L5.04199 8.51855ZM9.27148 8.14941L5.35449 6.87891L9.58105 2.05078L8.92773 1.37207L10.4512 0.617188L9.27148 8.14941ZM2.99316 6.11426L0.794922 5.40137L8.7041 1.48242L2.99316 6.11426Z" stroke="#6B21B0" /></svg> },
    isEmailCampaign && (contactStats['opted_out'] || 0) > 0 && { value: 'unsubscribed', label: 'Unsubscribed', count: contactStats['opted_out'], icon: <svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.9454 0.606883C5.92567 0.62009 5.90887 0.63722 5.89606 0.657205C5.88324 0.677189 5.87467 0.699599 5.8709 0.723039C5.86939 0.732104 5.86866 0.74128 5.8687 0.750469V0.751824C5.86866 0.759982 5.86922 0.768132 5.87039 0.776206L5.98705 1.6467L5.19343 2.57138C5.16893 2.59995 5.15465 2.63586 5.15284 2.67346C5.15103 2.71105 5.1618 2.74818 5.18344 2.77897L5.85125 3.72955L5.19648 4.75819C5.17892 4.78577 5.16972 4.81784 5.16999 4.85053C5.17026 4.88322 5.17999 4.91513 5.198 4.94242L5.75339 5.78429L5.24203 6.84985V6.02016C5.2421 5.98968 5.23384 5.95976 5.21815 5.93364L4.59978 4.89551L5.12587 3.99962C5.14201 3.9722 5.15009 3.94078 5.14919 3.90898C5.14829 3.87718 5.13845 3.84627 5.12079 3.8198L4.46297 2.83552L4.99888 1.97451C5.01417 1.94998 5.02293 1.92195 5.02432 1.89309C5.02572 1.86422 5.0197 1.83547 5.00684 1.80959L4.3861 0.563197C4.37066 0.532025 4.34593 0.506409 4.31532 0.48988C3.7189 0.167231 3.02625 0.0700921 2.36408 0.216234C1.70191 0.362376 1.11449 0.742029 0.709274 1.28574C0.304059 1.82946 0.108137 2.50088 0.157349 3.1772C0.20656 3.85351 0.497616 4.4895 0.977273 4.96883L5.10877 9.10033C5.14052 9.13207 5.18358 9.1499 5.22848 9.1499C5.27338 9.1499 5.31644 9.13207 5.34819 9.10033L9.47969 4.96883C9.97197 4.47529 10.2642 3.81705 10.3002 3.1209C10.3361 2.42474 10.1132 1.73991 9.67434 1.1983C9.2355 0.656694 8.61177 0.296616 7.9233 0.187422C7.23482 0.078228 6.53029 0.227641 5.9454 0.606883Z" fill="#EF4D56" stroke="#EF4D56" strokeWidth="0.3" /></svg> },
  ].filter(Boolean);

  const allMetricOptions = [
    { key: 'contactsReached', label: 'Contacts Enrolled', channels: ['all'] },
    { key: 'sequenceStarted', label: 'Messages Sent', channels: ['all'] },
    { key: 'replyRate', label: 'Replies Received', channels: ['email', 'sms', 'linkedin'] },
    { key: 'openRate', label: 'Open Rate', channels: ['email'] },
    { key: 'clickRate', label: 'Click Rate', channels: ['email'] },
    { key: 'opportunities', label: 'Opportunities', channels: ['email', 'voice'] },
    { key: 'bounceRate', label: 'Bounce Rate', channels: ['email'] },
    { key: 'positiveReplyRate', label: 'Positive Reply Rate', channels: ['email', 'sms', 'linkedin'] },
    { key: 'includeAutoReplies', label: 'Include Auto Replies', channels: ['email', 'sms'] },
    { key: 'meetingsBooked', label: 'Meetings Booked', channels: ['all'] },
  ].filter(m => {
    if (m['channels'].includes('all')) return true;
    if (m['channels'].includes('email') && isEmailCampaign) return true;
    if (m['channels'].includes('voice') && isVoiceCampaign) return true;
    if (m['channels'].includes('sms') && isSMSCampaign) return true;
    if (m['channels'].includes('linkedin') && isLinkedInCampaign) return true;
    return false;
  });

  const filteredMetricOptions = allMetricOptions.filter(m =>
    m['label'].toLowerCase().includes(metricsSearch.toLowerCase())
  );

  // Build ordered step analytics from backend data
  const orderedStepAnalytics = useMemo(() => {
    if (!analytics?.['stepAnalytics'] || !singleCampaign?.['sequence']) return analytics?.['stepAnalytics'] || [];
    const orderedNodes = buildOrderedNodeList(singleCampaign['sequence']['nodes'] || [], singleCampaign['sequence']['edges'] || [], singleCampaign['sequence']['entryNodeId']);
    const stepMap = {};
    (analytics['stepAnalytics'] || []).forEach(s => { stepMap[s['_id']] = s; });
    return orderedNodes.map(node => stepMap[node['id']] || { _id: node['id'], nodeName: node['name'], nodeType: node['type'], sent: 0, failed: 0, skipped: 0, totalTokens: 0, aiCount: 0 });
  }, [analytics, singleCampaign]);

  // Build time-series chart data from analytics.timelineChart
  const chartData = useMemo(() => {
    const raw = analytics?.['timelineChart'] || [];

    const ymd = (d) => d.toISOString().slice(0, 10);
    let filterStart = null, filterEnd = null;
    if (selectedPreset === 'custom') {
      const [cs, ce] = customRange;
      if (cs) filterStart = ymd(cs);
      if (ce) filterEnd = ymd(ce);
    } else if (selectedPreset !== 'all_time') {
      const today = new Date();
      const ago = (days) => { const d = new Date(today); d.setDate(d.getDate() - days); return d; };
      if (selectedPreset === 'today') { filterStart = ymd(today); filterEnd = ymd(today); }
      else if (selectedPreset === 'yesterday') { filterStart = ymd(ago(1)); filterEnd = ymd(ago(1)); }
      else if (selectedPreset === 'last_7_days') { filterStart = ymd(ago(6)); filterEnd = ymd(today); }
      else if (selectedPreset === 'last_4_weeks') { filterStart = ymd(ago(27)); filterEnd = ymd(today); }
      else if (selectedPreset === 'last_3_months') { filterStart = ymd(ago(89)); filterEnd = ymd(today); }
      else if (selectedPreset === 'week_to_date') { const d = new Date(today); d.setDate(d.getDate() - d.getDay()); filterStart = ymd(d); filterEnd = ymd(today); }
      else if (selectedPreset === 'month_to_date') { const d = new Date(today.getFullYear(), today.getMonth(), 1); filterStart = ymd(d); filterEnd = ymd(today); }
      else if (selectedPreset === 'year_to_date') { const d = new Date(today.getFullYear(), 0, 1); filterStart = ymd(d); filterEnd = ymd(today); }
    }

    const timeline = raw.filter(entry => {
      const date = entry['_id']?.['date'];
      if (!date || !filterStart) return true;
      if (date < filterStart) return false;
      if (filterEnd && date > filterEnd) return false;
      return true;
    });
    const categories_set = new Set();
    const sentData = {};
    const openedData = {};
    const bouncedData = {};
    const repliedData = {};
    const failedData = {};

    timeline.forEach(entry => {
      const date = entry['_id']?.['date'];
      if (!date) return;
      categories_set.add(date);
      sentData[date] = (sentData[date] || 0) + (entry['sent'] || 0);
      openedData[date] = (openedData[date] || 0) + (entry['opened'] || 0);
      bouncedData[date] = (bouncedData[date] || 0) + (entry['bounced'] || 0);
      repliedData[date] = (repliedData[date] || 0) + (entry['replied'] || 0);
      failedData[date] = (failedData[date] || 0) + (entry['failed'] || 0);
    });

    const categories = Array.from(categories_set).sort();

    if (categories.length === 0) return { series: [], categories: [] };

    // Check if this is a voice-only chart (all sent data comes from voice channel)
    const voiceRaw = analytics?.['voiceTimelineChart'] || [];
    const isVoiceChart = voiceRaw.length > 0 || (timeline.every(e => e['_id']?.['channel'] === 'voice'));

    if (isVoiceChart && voiceRaw.length > 0) {
      // Voice campaign — merge sent dates with call-log outcome dates
      const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-color').trim() || '#120348';
      const allDates = new Set([...categories, ...voiceRaw.map(e => e['_id']?.['date']).filter(Boolean)]);
      const vcategories = Array.from(allDates).sort();
      const answeredByDate = {}, passByDate = {}, failByDate = {};
      voiceRaw.forEach(e => {
        const d = e['_id']?.['date'];
        if (!d) return;
        answeredByDate[d] = (answeredByDate[d] || 0) + (e['answered'] || 0);
        passByDate[d] = (passByDate[d] || 0) + (e['pass'] || 0);
        failByDate[d] = (failByDate[d] || 0) + (e['fail'] || 0);
      });
      const voiceSeries = [
        { name: 'Calls Made', data: vcategories.map(d => sentData[d] || 0), color: `${primaryColor}33` },
        { name: 'Answered', data: vcategories.map(d => answeredByDate[d] || 0), color: primaryColor },
        { name: 'Pass', data: vcategories.map(d => passByDate[d] || 0), color: '#22c55e' },
      ].filter(s => s.data.some(v => v > 0));
      return { series: voiceSeries, categories: vcategories };
    }

    const series = [
      {
        name: 'Sent',
        data: categories.map(d => sentData[d] || 0),
        color: '#C4CAFF',
      },
      {
        name: 'Opened',
        data: categories.map(d => openedData[d] || 0),
        color: '#FFD2D4',
      },
      {
        name: 'Bounced',
        data: categories.map(d => bouncedData[d] || 0),
        color: '#FFC47C',
      },
      {
        name: 'Replied',
        data: categories.map(d => repliedData[d] || 0),
        color: '#C2FFD1',
      },
      {
        name: 'Failed',
        data: categories.map(d => failedData[d] || 0),
        color: '#EF4D56',
      },
    ].filter(s => s.data.some(v => v > 0));

    return { series, categories };
  }, [analytics, selectedPreset, customRange]);

  const areaChartOptions = useMemo(() => ({
    chart: { type: 'area', toolbar: { show: false }, zoom: { enabled: false } },
    dataLabels: { enabled: false },
    stroke: { curve: 'smooth', width: 2 },
    xaxis: { categories: chartData['categories'], labels: { style: { fontSize: '11px' }, formatter: (val) => { if (!val) return ''; const d = new Date(val); return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); } } },
    yaxis: { min: 0, forceNiceScale: true, tickAmount: 5, labels: { style: { fontSize: '11px' }, formatter: (val) => (Number.isInteger(val) ? val : '') } },
    fill: { type: 'gradient', gradient: { shadeIntensity: 1, opacityFrom: 0.4, opacityTo: 0.1, stops: [0, 100] } },
    tooltip: { x: { format: 'MMM dd, yyyy' } },
    legend: { position: 'top', horizontalAlign: 'right', fontSize: '12px', show: false },
    colors: chartData['series'].map(s => s['color']),
    grid: { borderColor: '#F3F4F6' }
  }), [chartData]);

  if (singleCampaignLoading) return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}><CircularProgress sx={{ color: 'var(--primary-color)' }} /></Box>;

  const campaign = singleCampaign || {};
  // table stats
  const headerScrollHeight = 'calc(100vh - 415px)';
  const responsiveClass = 'datatable--paginated contact-table';


  return (
    <div className="page-content campaign-page-content campaign-wizard">
      <div className="campaign-wizard-header">
        <div className="wizard-header-left">
          <button className="header-exit-btn" onClick={() => routerHistory.push(getWorkspacePath('/campaigns', currentWorkspace?.['_id']))}>
            Exit
          </button>

          {editingName ? (
            <input
              autoFocus
              value={campaign['name'] || ''}
              onChange={e => {/* hook into your update dispatch here */ }}
              onBlur={() => setEditingName(false)}
              onKeyDown={e => { if (e.key === 'Enter' || e.key === 'Escape') setEditingName(false); }}
              style={{
                fontSize: 'inherit',
                fontWeight: '500',
                fontFamily: 'inherit',
                border: 'none',
                borderBottom: 'none',
                outline: 'none',
                background: 'transparent',
              }}
            />
          ) : (
            <Tooltip title={campaign['name']} placement="top" arrow>
              <h1
                className="campaign-title"
                onClick={() => setEditingName(true)}
                style={{ cursor: 'pointer' }}
              >
                {campaign['name']}
              </h1>
            </Tooltip>
          )}
          <div className="analytics-header-chips">
            {campaign['status'] && (() => {
              const sc = statusConfig[campaign['status']];
              return (
                <span className="wizard-channel-chip" style={{ '--chip-color': sc ? sc['color'] : '#6B7280' }}>
                  {campaign['status'].charAt(0).toUpperCase() + campaign['status'].slice(1)}
                </span>
              );
            })()}
            {activeChannels.map(ch => {
              const Icon = ch['icon'];
              return (
                <span key={ch['key']} className="wizard-channel-chip" style={{ '--chip-color': ch['color'] }}>
                  <Icon sx={{ fontSize: 12 }} />{ch['label']}
                </span>
              );
            })}
          </div>
          {(() => {
            // Divide by enrolled contacts (status-bucket sum), not the audience-size metric — keeps this % identical to the campaigns list page
            const total = Object.keys(statusConfig).reduce((a, k) => a + (campaignWideStats[k] || 0), 0) || (metrics['totalContacts'] || 0);
            const done = (campaignWideStats['completed'] || 0) + (campaignWideStats['failed'] || 0) + (campaignWideStats['opted_out'] || 0);
            const progress = total > 0 ? Math.round((done / total) * 100) : 0;
            const color = progress <= 10 ? '#e53935' : progress <= 49 ? '#fb8c00' : '#16A34A';
            // Spell out the processed-contacts math so "done" is never read as "sent successfully"
            const doneBreakdown = [
              (campaignWideStats['completed'] || 0) > 0 && `${campaignWideStats['completed']} completed`,
              (campaignWideStats['failed'] || 0) > 0 && `${campaignWideStats['failed']} failed`,
              (campaignWideStats['opted_out'] || 0) > 0 && `${campaignWideStats['opted_out']} opted out`
            ].filter(Boolean).join(' · ');
            return (
              <div className="analytics-header-progress" title={`${done} of ${total} contacts processed${doneBreakdown ? ` — ${doneBreakdown}` : ''}`}>
                <div className="analytics-header-progress-inner">
                  <span className="analytics-header-progress-label">Progress</span>
                  <span className="analytics-header-progress-pct" style={{ color }}>{progress}%</span>
                </div>
                <div className="analytics-header-progress-bar">
                  <div className="analytics-header-progress-fill" style={{ width: `${progress}%`, background: color }} />
                </div>
              </div>
            );
          })()}
        </div>

        <div className="wizard-header-right">
          {campaign['status'] === 'active' && (
            <button className="analytics-header-action-btn analytics-header-pause-btn" onClick={() => dispatch(pauseCampaign({ id, successCallback: () => dispatch(getSingleCampaign(id)) }))}>
              <PauseIcon sx={{ fontSize: 14 }} /> Pause
            </button>
          )}
          {campaign['status'] === 'paused' && (
            <button className="analytics-header-action-btn analytics-header-resume-btn" onClick={() => dispatch(resumeCampaign({ id, successCallback: () => dispatch(getSingleCampaign(id)) }))}>
              <PlayIcon sx={{ fontSize: 14 }} /> Resume
            </button>
          )}
          <button className="btn-save-continue" onClick={() => routerHistory.push(getWorkspacePath(`/campaigns/${id}`, currentWorkspace?.['_id']))}>
            <EditIcon fontSize="small" /> Edit
          </button>
        </div>
      </div>

      <div className="campaign-wizard-content campaign-analytics-content">
        <div className="analytics-content-inner">
          <div className="campaign-overview-header">
            <h2>Campaign Analytics</h2>
            <Tabs value={activeTab} onChange={(e, v) => setActiveTab(v)} sx={{ minHeight: 36, '& .MuiTab-root': { minHeight: 36, py: 0.5, fontSize: 13 } }}>
              <Tab label="Overview" />
              <Tab label="Contacts" />
            </Tabs>
            {activeTab === 0 && (
            <div className="right-stats">
              <div className="ca-date-range-wrapper" ref={dateDropdownRef}>
                    <div className="ca-date-range-btn" onClick={() => setShowDateDropdown(prev => !prev)}>
                      <i className="fa fa-calendar" />
                      <span>{DATE_PRESET_LABEL(selectedPreset, customRange)}</span>
                      <i className={`fa ${showDateDropdown ? 'fa-angle-up' : 'fa-angle-down'}`} />
                    </div>
                    <Tooltip title="Refresh" placement="bottom" arrow>
                      <button className="btn-share-continue" onClick={handleRefresh}>
                        <RefreshIcon sx={{ fontSize: 15 }} />
                      </button>
                    </Tooltip>
                    {showDateDropdown && (
                      <div className="ca-date-dropdown">
                        {!showCustomPicker ? (
                          <>
                            {DATE_PRESETS.map(p => (
                              <button key={p.value} className={`ca-date-preset-item${selectedPreset === p.value ? ' active' : ''}`} onClick={() => handlePresetSelect(p.value)}>
                                {p.label}
                              </button>
                            ))}
                            <div className="ca-date-dropdown-divider" />
                            <button className={`ca-date-preset-item${selectedPreset === 'custom' ? ' active' : ''}`} onClick={() => handlePresetSelect('custom')}>
                              Custom range
                            </button>
                          </>
                        ) : (
                          <div className="ca-date-custom-panel">
                            <button className="ca-date-back-btn" onClick={() => setShowCustomPicker(false)}>
                              <i className="fa fa-angle-left" /> Back
                            </button>
                            <DatePicker selectsRange startDate={customRange[0]} endDate={customRange[1]} onChange={handleCustomRangeChange} monthsShown={2} inline maxDate={new Date()} />
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  <div ref={metricsDropdownRef} style={{ position: 'relative' }}>
                    <Tooltip title="Metrics" placement="bottom" arrow>
                      <button
                        className="btn-share-continue"
                        onClick={() => setMetricsDropdownOpen(prev => !prev)}
                      >
                        <svg width="14" height="14" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8.0644 14.752H6.68755C6.46244 14.7517 6.24521 14.6691 6.07691 14.5196C5.90861 14.3701 5.80091 14.1641 5.77416 13.9406L5.62726 12.7875C5.33699 12.6933 5.0546 12.5763 4.78271 12.4377L3.8644 13.1514C3.68709 13.2907 3.46463 13.3599 3.23955 13.3456C3.01447 13.3313 2.80255 13.2346 2.64429 13.0739L1.67619 12.1058C1.51639 11.9477 1.42041 11.7363 1.40658 11.5119C1.39274 11.2875 1.46203 11.0659 1.6012 10.8894L2.31483 9.97048C2.17572 9.69882 2.05876 9.41639 1.96508 9.12593L0.809513 8.97902C0.586282 8.95145 0.380813 8.84328 0.231738 8.67485C0.0826626 8.50642 0.000251693 8.28933 0 8.0644L0 6.68755C0 6.22225 0.348515 5.82948 0.811357 5.77416L1.96447 5.62726C2.05868 5.33699 2.17563 5.0546 2.31421 4.78271L1.6012 3.8644C1.46147 3.68708 1.39215 3.46439 1.40656 3.23909C1.42097 3.01379 1.51808 2.80175 1.67926 2.64367L2.64736 1.67558C2.80554 1.51589 3.01694 1.42 3.24128 1.40617C3.46561 1.39234 3.68719 1.46154 3.86378 1.60059L4.78209 2.31483C5.05415 2.17613 5.33675 2.05919 5.62726 1.96508L5.77416 0.809513C5.82948 0.348515 6.22225 0 6.68755 0H8.0644C8.5297 0 8.92247 0.348515 8.97779 0.811357L9.1247 1.96447C9.41851 2.05974 9.70125 2.17714 9.96986 2.31421L10.8882 1.60059C11.0654 1.46103 11.288 1.39182 11.5132 1.40622C11.7383 1.42063 11.9502 1.51764 12.1083 1.67865L13.0764 2.64675C13.4065 2.96699 13.4396 3.4913 13.1514 3.86317L12.4377 4.78209C12.5754 5.0507 12.6928 5.33345 12.7875 5.62664L13.9431 5.77355C14.1661 5.80112 14.3714 5.90922 14.5204 6.07754C14.6694 6.24585 14.7517 6.46279 14.752 6.68755V8.0644C14.752 8.5297 14.4034 8.92247 13.9406 8.97779L12.7875 9.1247C12.6933 9.41496 12.5763 9.69736 12.4377 9.96925L13.1514 10.8876C13.2909 11.0648 13.3601 11.2874 13.3457 11.5125C13.3313 11.7377 13.2343 11.9496 13.0733 12.1077L12.1052 13.0758C11.9472 13.2357 11.7357 13.3318 11.5113 13.3456C11.2869 13.3594 11.0653 13.2901 10.8888 13.1508L9.96986 12.4371C9.69821 12.5762 9.41578 12.6932 9.12531 12.7869L8.97841 13.9424C8.95098 14.1656 8.84293 14.3711 8.6746 14.5202C8.50627 14.6693 8.28926 14.7517 8.0644 14.752ZM4.75136 11.7647C4.80238 11.7647 4.85462 11.7776 4.90134 11.8034C5.2463 11.9954 5.61217 12.1472 5.99175 12.2558C6.04946 12.2724 6.10105 12.3055 6.14015 12.351C6.17926 12.3966 6.20417 12.4526 6.2118 12.5121L6.38391 13.8644C6.40235 14.0187 6.53573 14.1373 6.68755 14.1373H8.0644C8.13892 14.1363 8.21058 14.1084 8.26624 14.0589C8.3219 14.0093 8.35783 13.9414 8.36743 13.8675L8.54015 12.5127C8.54779 12.4532 8.5727 12.3972 8.6118 12.3516C8.65091 12.3061 8.7025 12.273 8.7602 12.2564C9.13979 12.1478 9.50565 11.996 9.85062 11.804C9.90326 11.7746 9.96341 11.7614 10.0235 11.766C10.0837 11.7706 10.1411 11.7928 10.1887 11.8298L11.2643 12.6658C11.3223 12.7124 11.3954 12.7361 11.4696 12.7322C11.5439 12.7283 11.6142 12.6973 11.667 12.6449L12.6412 11.6706C12.6945 11.6179 12.7264 11.5473 12.7308 11.4724C12.7353 11.3975 12.7119 11.3236 12.6652 11.265L11.8292 10.1893C11.7922 10.1417 11.7701 10.0843 11.7655 10.0241C11.7609 9.96404 11.7741 9.9039 11.8034 9.85123C11.9954 9.50627 12.1472 9.1404 12.2558 8.76082C12.2724 8.70311 12.3055 8.65152 12.351 8.61242C12.3966 8.57331 12.4526 8.5484 12.5121 8.54077L13.8644 8.36866C13.9389 8.35934 14.0075 8.32342 14.0577 8.26752C14.1078 8.21162 14.1361 8.13949 14.1373 8.0644V6.68755C14.1363 6.61303 14.1084 6.54137 14.0589 6.48571C14.0093 6.43005 13.9414 6.39413 13.8675 6.38452L12.5127 6.2118C12.4532 6.20417 12.3972 6.17926 12.3516 6.14015C12.3061 6.10105 12.273 6.04946 12.2564 5.99175C12.1478 5.61217 11.996 5.2463 11.804 4.90134C11.7745 4.84874 11.7611 4.78856 11.7657 4.72839C11.7703 4.66823 11.7926 4.61077 11.8298 4.56327L12.6658 3.48761C12.7126 3.4299 12.7364 3.35693 12.7326 3.28273C12.7289 3.20852 12.6979 3.13832 12.6455 3.08562L11.6713 2.11137C11.6187 2.0577 11.548 2.02552 11.473 2.02109C11.3981 2.01666 11.3241 2.0403 11.2656 2.0874L10.1899 2.92335C10.1422 2.96046 10.0847 2.9827 10.0245 2.98729C9.96423 2.99188 9.90397 2.97862 9.85123 2.94916C9.50635 2.75697 9.14046 2.60517 8.76082 2.49677C8.70311 2.48021 8.65152 2.44711 8.61242 2.40156C8.57331 2.35601 8.5484 2.3 8.54077 2.24045L8.36866 0.888191C8.35948 0.813564 8.32362 0.744774 8.2677 0.694506C8.21179 0.644238 8.13958 0.615881 8.0644 0.614665H6.68755C6.61303 0.61567 6.54137 0.643506 6.48571 0.693068C6.43005 0.742631 6.39413 0.810597 6.38452 0.884503L6.2118 2.23922C6.20413 2.29883 6.17921 2.35489 6.14012 2.40053C6.10103 2.44617 6.04947 2.47941 5.99175 2.49615C5.61213 2.60434 5.24624 2.75594 4.90134 2.94793C4.84865 2.97748 4.78843 2.99084 4.7282 2.98636C4.66796 2.98188 4.61039 2.95975 4.56266 2.92273L3.48699 2.08679C3.42928 2.03999 3.35632 2.01617 3.28211 2.01992C3.20791 2.02366 3.13771 2.0547 3.085 2.10707L2.11076 3.08193C2.05746 3.1347 2.02554 3.20531 2.02111 3.28018C2.01669 3.35505 2.04008 3.42892 2.08679 3.48761L2.92273 4.56327C2.95972 4.61088 2.98188 4.66831 2.98647 4.72842C2.99107 4.78853 2.97787 4.84867 2.94855 4.90134C2.75627 5.24618 2.60446 5.61207 2.49615 5.99175C2.47959 6.04946 2.44649 6.10105 2.40094 6.14015C2.35539 6.17926 2.29938 6.20417 2.23984 6.2118L0.887576 6.38391C0.813061 6.39297 0.744353 6.42872 0.694176 6.48455C0.643998 6.54038 0.615751 6.6125 0.614665 6.68755V8.0644C0.614665 8.21622 0.733295 8.34961 0.884503 8.36743L2.23922 8.54015C2.29877 8.54779 2.35478 8.5727 2.40033 8.6118C2.44588 8.65091 2.47898 8.7025 2.49554 8.7602C2.60618 9.14498 2.75862 9.51194 2.94793 9.85062C2.9775 9.90322 2.99082 9.9634 2.98623 10.0236C2.98163 10.0837 2.95933 10.1412 2.92212 10.1887L2.08617 11.2643C2.03938 11.3221 2.01556 11.395 2.0193 11.4692C2.02305 11.5434 2.05409 11.6136 2.10646 11.6663L3.0807 12.6406C3.1334 12.694 3.20402 12.726 3.27894 12.7304C3.35385 12.7349 3.42775 12.7114 3.48638 12.6646L4.56204 11.8286C4.61659 11.7874 4.68301 11.765 4.75136 11.7647Z" fill="currentColor" />
                          <path d="M7.37594 10.4489C5.68131 10.4489 4.30261 9.0702 4.30261 7.37557C4.30261 5.68094 5.68131 4.30225 7.37594 4.30225C9.07057 4.30225 10.4493 5.68094 10.4493 7.37557C10.4493 9.0702 9.07057 10.4489 7.37594 10.4489ZM7.37594 4.91691C6.01999 4.91691 4.91728 6.01962 4.91728 7.37557C4.91728 8.73152 6.01999 9.83423 7.37594 9.83423C8.73189 9.83423 9.83459 8.73152 9.83459 7.37557C9.83459 6.01962 8.73189 4.91691 7.37594 4.91691Z" fill="currentColor" />
                        </svg>
                      </button>
                    </Tooltip>

                    {/* Dropdown Panel */}
                    {metricsDropdownOpen && (
                      <div style={{
                        position: 'absolute',
                        top: 'calc(100% + 6px)',
                        right: 0,
                        width: 240,
                        background: '#fff',
                        border: '1px solid #E5E7EB',
                        borderRadius: 10,
                        boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                        zIndex: 1000,
                        overflow: 'hidden',
                      }}>
                        {/* Search */}
                        <div style={{ padding: '10px 12px', borderBottom: '1px solid #F3F4F6' }}>
                          <input
                            autoFocus
                            type="text"
                            placeholder="Search..."
                            value={metricsSearch}
                            onChange={e => setMetricsSearch(e.target.value)}
                            style={{
                              width: '100%',
                              border: 'none',
                              outline: 'none',
                              fontSize: 13,
                              color: '#111827',
                              background: 'transparent',
                              fontFamily: 'inherit',
                            }}
                          />
                        </div>

                        {/* Options */}
                        <div style={{ maxHeight: 280, overflowY: 'auto' }}>
                          {filteredMetricOptions.length === 0 ? (
                            <div style={{ padding: '12px 16px', fontSize: 13, color: '#9CA3AF', textAlign: 'center' }}>
                              No results
                            </div>
                          ) : filteredMetricOptions.map(m => (
                            <div
                              key={m.key}
                              onClick={() => toggleMetric(m.key)}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '9px 16px',
                                cursor: 'pointer',
                                fontSize: 13,
                                color: '#111827',
                                background: '#fff',
                                transition: 'background 0.15s',
                              }}
                              onMouseEnter={e => e.currentTarget.style.background = '#F9FAFB'}
                              onMouseLeave={e => e.currentTarget.style.background = '#fff'}
                            >
                              <span style={{ fontWeight: 400 }}>{m.label}</span>
                              {enabledMetrics[m.key] ? (
                                <span style={{
                                  width: 20, height: 20,
                                  borderRadius: '50%',
                                  background: '#22C55E',
                                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                                  flexShrink: 0,
                                }}>
                                  <svg width="11" height="8" viewBox="0 0 11 8" fill="none">
                                    <path d="M1 4L4 7L10 1" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                                  </svg>
                                </span>
                              ) : (
                                <span style={{
                                  width: 20, height: 20,
                                  borderRadius: '50%',
                                  border: '2px solid #D1D5DB',
                                  flexShrink: 0,
                                }} />
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                  <Tooltip title="Activity Log" placement="bottom" arrow>
                    <button className="btn-share-continue ca-log-drawer-btn" onClick={() => setAuditLogOpen(true)}>
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 12h6M9 8h6M9 16h4M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                  </Tooltip>
                </div>
          )}
          </div>
          {activeTab === 0 && (
            <div className="ca-analytics-body">
              {analyticsLoading && (
                <div className="ca-analytics-loading-overlay">
                  <i className="fa fa-spinner fa-spin" />
                </div>
              )}
              {campaign['status'] === 'stopped' && campaign['schedule']?.['stopReason'] && (

                <div className="campaign-analytics-stop-banner">
                  <WarnIcon sx={{ fontSize: 16, color: '#d97706', flexShrink: 0 }} />
                  <span><strong>Campaign stopped</strong> — {campaign['schedule']['stopReason']}</span>
                </div>
              )}

              {/* Row 1: Channel-aware Stat Cards */}
              <Grid container spacing={2} sx={{ mb: 3 }}>
                {enabledMetrics['contactsReached'] && <Grid item xs={6} sm={4} md={2.4}><StatCard title="Contacts Enrolled" className="card-green" value={metrics['totalContacts'] || 0} subtitle={`${metrics['contactsReached'] || 0} reached`} icon={PersonIconCard} color="primary" /></Grid>}
                {enabledMetrics['sequenceStarted'] && <Grid item xs={6} sm={4} md={2.4}>
                  <StatCard
                    title={isPureVoice ? 'Calls Made' : (isSMSCampaign && !isEmailCampaign ? 'SMS Sent' : 'Messages Sent')}
                    className={isPureVoice ? 'card-blue' : 'card-orenge'}
                    value={isPureVoice ? (metrics['callsMade'] || 0) : totalSent}
                    subtitle={isPureVoice
                      ? ((metrics['callsAnswered'] || 0) > 0 ? `${metrics['callsAnswered']} answered` : 'across 1 channel')
                      : (activeChannelCount > 0 ? `across ${activeChannelCount} channel${activeChannelCount !== 1 ? 's' : ''}` : undefined)}
                    icon={isPureVoice ? CallsMadeIcon : EmailIconCard}
                    color="info"
                  />
                </Grid>}
                {isVoiceCampaign && (
                  <Grid item xs={6} sm={4} md={2.4}>
                    <StatCard title="Calls Answered" className="card-green" value={metrics['callsAnswered'] || 0}
                      subtitle={(metrics['callsMade'] || 0) > 0
                        ? `${metrics['callsAnswered'] || 0}/${metrics['callsMade']} answered (${Math.round(((metrics['callsAnswered'] || 0) / metrics['callsMade']) * 100)}%)`
                        : '0% answer rate'}
                      icon={CallsAnsweredIcon} color="success" />
                  </Grid>
                )}
                {!isPureVoice && enabledMetrics['replyRate'] && (
                  <Grid item xs={6} sm={4} md={2.4}><StatCard title="Replies Received" className="card-blue" value={totalReplies} subtitle={totalSent > 0 ? `${Math.round((totalReplies / totalSent) * 100)}% reply rate` : undefined} icon={TrendingUpIconCard} color="success" /></Grid>
                )}
                {isEmailCampaign && emailSent > 0 && enabledMetrics['openRate'] && (
                  <Grid item xs={6} sm={4} md={2.4}>
                    <StatCard title="Open Rate" className="card-green" value={`${openRate}%`} subtitle={`${emailOpened.toLocaleString()} of ${emailSent.toLocaleString()} opened`} icon={VisibilityIcon} color="success" />
                  </Grid>
                )}
                {((isEmailCampaign && emailClicked > 0) || isVoiceCampaign) && enabledMetrics['opportunities'] && (
                  <Grid item xs={6} sm={4} md={2.4}>
                    <StatCard title="Opportunities" className={isVoiceCampaign ? 'card-green' : 'card-blue'}
                      value={emailClicked + (metrics['callsSucceeded'] || 0)}
                      subtitle={isVoiceCampaign && isEmailCampaign
                        ? `${emailClicked} clicks • ${metrics['callsSucceeded'] || 0} successful calls`
                        : (isVoiceCampaign
                          ? `${metrics['callsSucceeded'] || 0}/${metrics['callsAnswered'] || 0} answered calls met objective`
                          : `${clickRate}% clicked a link`)}
                      icon={isVoiceCampaign ? CelebrationIcon : TouchAppIcon} color={isVoiceCampaign ? 'success' : 'info'} />
                  </Grid>
                )}
                {isEmailCampaign && enabledMetrics['clickRate'] && (
                  <Grid item xs={6} sm={4} md={2.4}>
                    <StatCard title="Click Rate" className="card-blue" value={`${clickRate}%`} subtitle={`${emailClicked.toLocaleString()} of ${emailSent.toLocaleString()} clicked`} icon={LinkClickIcon} color="info" />
                  </Grid>
                )}
                {isEmailCampaign && enabledMetrics['bounceRate'] && (
                  <Grid item xs={6} sm={4} md={2.4}>
                    <StatCard title="Bounce Rate" className="card-red" value={emailSent > 0 ? `${Math.round(((metrics['emailsBounced'] || 0) / emailSent) * 100)}%` : '0%'} subtitle={`${metrics['emailsBounced'] || 0} bounced`} icon={ErrorIcon} color="error" />
                  </Grid>
                )}
                {isEmailCampaign && enabledMetrics['positiveReplyRate'] && (
                  <Grid item xs={6} sm={4} md={2.4}>
                    <StatCard title="Positive Replies" className="card-green" value={metrics['positiveReplies'] || 0} subtitle={totalReplies > 0 ? `${Math.round(((metrics['positiveReplies'] || 0) / totalReplies) * 100)}% of replies` : 'of all replies'} icon={CheckCircleIcon} color="success" />
                  </Grid>
                )}
                {enabledMetrics['meetingsBooked'] && (
                  <Grid item xs={6} sm={4} md={2.4}>
                    <StatCard title="Meetings Booked" className="card-purple" value={metrics['meetingsBooked'] || 0} subtitle={metrics['totalContacts'] > 0 ? `${Math.round(((metrics['meetingsBooked'] || 0) / metrics['totalContacts']) * 100)}% of contacts` : undefined} icon={CalendarIcon} color="secondary" />
                  </Grid>
                )}
              </Grid>


              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={8}>
                  {/* Row 2: Multi-Channel Area Chart */}
                  <Paper sx={{ p: 3, mb: 3 }}>
                    <Typography variant="h6" sx={{ mb: 1, fontSize: '18px', fontWeight: 600, textTransform: 'capitalize' }}>
                      {isPureVoice ? 'Call Activity Over Time' : 'Message Overtime'}
                    </Typography>
                    {chartData['series'].length > 0 ? (
                      <Chart options={areaChartOptions} series={chartData['series']} type="area" height={300} />
                    ) : (
                      <div className="canalytics-chart-empty">
                        <div className="canalytics-chart-empty-bars">
                          {[40, 65, 30, 80, 50, 90, 45].map((h, i) => (
                            <div key={i} className="canalytics-chart-empty-bar" style={{ height: `${h}%` }} />
                          ))}
                        </div>
                        <div className="canalytics-chart-empty-text">
                          <span className="canalytics-chart-empty-title">No activity yet</span>
                          <span className="canalytics-chart-empty-sub">Data will appear here once the campaign starts sending</span>
                        </div>
                      </div>
                    )}
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={12} md={4}>
                  {(() => {
                    const emailBounced = metrics['emailsBounced'] || 0;
                    const emailReplied = metrics['emailsReplied'] || 0;
                    // Contacts never sent to because their email was invalid/unverified/etc. — a different
                    // population than emailBounced (which is a real send-time bounce). Same underlying data
                    // as the Steps table's Skipped column (executionHistory.status === 'skipped').
                    const emailInvalid = contactStats['skipped'] || 0;

                    // Voice campaign — show call disposition donut
                    if (isVoiceCampaign && !isEmailCampaign) {
                      const callsMade = metrics['callsMade'] || 0;
                      const callsAnswered = metrics['callsAnswered'] || 0;
                      const callsVoicemail = metrics['callsVoicemail'] || 0;
                      const callsFailed = metrics['callsFailed'] || 0;
                      const callsOther = Math.max(0, callsMade - callsAnswered - callsVoicemail - callsFailed);
                      if (callsMade === 0) return null;
                      const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-color').trim() || '#120348';
                      const voiceFunnelData = [
                        { label: 'Answered', value: callsAnswered, color: primaryColor },
                        { label: 'Voicemail', value: callsVoicemail, color: '#F7931A' },
                        { label: 'No Answer', value: callsOther, color: '#E5E7EB' },
                        { label: 'Failed', value: callsFailed, color: '#EF4D56' },
                      ].filter(d => d.value > 0);
                      const voicePieOptions = {
                        chart: { type: 'donut', toolbar: { show: false } },
                        labels: voiceFunnelData.map(d => d.label),
                        colors: voiceFunnelData.map(d => d.color),
                        states: { hover: { filter: { type: 'none' } }, active: { filter: { type: 'none' } } },
                        dataLabels: { enabled: false },
                        plotOptions: { pie: { donut: { size: '45%', labels: { show: true, total: { show: true, label: 'Total', formatter: () => callsMade } } } } },
                        legend: { show: false },
                        stroke: { width: 3, colors: ['#fff'] },
                        tooltip: { y: { formatter: (val) => val.toLocaleString() } },
                      };
                      return (
                        <Paper sx={{ p: 2.5, height: '100%' }}>
                          <Typography variant="h6" sx={{ mb: 1, fontSize: '18px', fontWeight: 600 }}>Call Outcomes</Typography>
                          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Chart options={voicePieOptions} series={voiceFunnelData.map(d => d.value)} type="donut" height={220} width="100%" />
                            <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', gap: 1.5, mt: 1 }}>
                              {voiceFunnelData.map((d) => {
                                const pct = callsMade > 0 ? Math.round((d.value / callsMade) * 100) : 0;
                                return (
                                  <Box key={d.label} sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                                    <Box sx={{ width: 9, height: 9, borderRadius: '50%', bgcolor: d.color, flexShrink: 0 }} />
                                    <Typography variant="caption" color="textSecondary" fontWeight={500}>{d.label}</Typography>
                                    <Typography variant="caption" fontWeight={700} sx={{ color: '#111827' }}>{d.value.toLocaleString()}</Typography>
                                    <Typography variant="caption" sx={{ color: '#9CA3AF' }}>({pct}%)</Typography>
                                  </Box>
                                );
                              })}
                            </Box>
                          </Box>
                        </Paper>
                      );
                    }

                    if (emailSent === 0) return null;

                    const funnelData = [
                      { label: 'Sent', value: emailSent, color: '#C4CAFF' },
                      { label: 'Opened', value: emailOpened, color: '#FFD2D4' },
                      { label: 'Clicked', value: emailClicked, color: '#92BFFF' },
                      { label: 'Bounced', value: emailBounced, color: '#FFC47C' },
                      { label: 'Replied', value: emailReplied, color: '#C2FFD1' },
                      { label: 'Invalid', value: emailInvalid, color: '#D9A9E0' },
                    ].filter(d => d.value > 0);

                    const pieOptions = {
                      chart: {
                        type: 'donut',
                        toolbar: { show: false },
                      },
                      labels: funnelData.map(d => d.label),
                      colors: funnelData.map(d => d.color),
                      states: {
                        hover: {
                          filter: {
                            type: 'none',
                          }
                        },
                        active: {
                          filter: {
                            type: 'none',
                          }
                        }
                      },
                      dataLabels: {
                        enabled: false,
                        formatter: (val) => `${val.toFixed(1)}%`,
                        style: {
                          fontSize: '12px',
                          fontFamily: 'inherit',
                          fontWeight: 600,
                        },
                        dropShadow: { enabled: false },
                      },
                      plotOptions: {
                        pie: {
                          donut: {
                            size: '45%',
                            labels: {
                              show: false,
                            }
                          }
                        }
                      },
                      legend: { show: false },
                      stroke: { width: 3, colors: ['#fff'] },
                      tooltip: {
                        y: {
                          formatter: (val) => `${val.toLocaleString()}`
                        }
                      },
                      responsive: [{
                        breakpoint: 480,
                        options: {
                          chart: { width: 200 },
                          legend: { position: 'bottom' }
                        }
                      }]
                    };

                    return (
                      <Paper sx={{ p: 2.5, height: '100%' }}>
                        <Typography variant="h6" sx={{ mb: 1, fontSize: '18px', fontWeight: 600, textTransform: 'capitalize' }}>Email</Typography>
                        <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                          <Grid item xs={12} sm={12} md={8}>
                            {/* Donut Chart */}
                            <Chart
                              options={pieOptions}
                              series={funnelData.map(d => d.value)}
                              type="donut"
                              height={280}
                            />
                          </Grid>
                          <Grid item xs={12} sm={12} md={4}>
                            {/* Stats Legend */}
                            <Box sx={{ mt: 1.5, display: 'flex', flexDirection: 'column', gap: 0.6 }}>
                              {funnelData.map((d) => {
                                const pct = emailSent > 0 ? Math.round((d.value / emailSent) * 100) : 0;
                                return (
                                  <Box
                                    key={d.label}
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between',
                                      px: 1,
                                      py: 0.4,
                                      borderRadius: 1,
                                      '&:hover': { bgcolor: '#F9FAFB' }
                                    }}
                                  >
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                      <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: d.color, flexShrink: 0 }} />
                                      <Typography variant="caption" color="textSecondary" fontWeight={500}>
                                        {d.label}
                                      </Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                                      <Typography variant="caption" fontWeight={700} sx={{ color: '#111827' }}>
                                        {d.value.toLocaleString()}
                                      </Typography>
                                      {d.label !== 'Sent' && (
                                        <Typography variant="caption" sx={{ color: '#9CA3AF' }}>
                                          | {pct}%
                                        </Typography>
                                      )}
                                    </Box>
                                  </Box>
                                );
                              })}
                            </Box>
                          </Grid>
                        </Grid>
                      </Paper>
                    );
                  })()}
                </Grid>
              </Grid>

              {/* Row 4: Step Analytics / Activity sub-tabs */}
              <Paper className="table-analytics-box" sx={{ overflow: 'hidden', p: 2.5, mt: 3 }}>
                <Box sx={{ borderBottom: '1px solid #E5E7EB' }}>
                  <Tabs value={overviewSubTab} onChange={(e, v) => setOverviewSubTab(v)} sx={{ minHeight: 36, px: 2, '& .MuiTab-root': { minHeight: 36, py: 0.5, fontSize: 13 } }}>
                    <Tab label="Steps" />
                    <Tab label="Activity" />
                    {(isEmailCampaign || isVoiceCampaign) && (
                      <Tab label={<span className="campaign-channel-health-tab-label">Integrations{unhealthyIntegrations > 0 && <span className="campaign-channel-health-tab-badge">{unhealthyIntegrations}</span>}</span>} />
                    )}
                  </Tabs>
                </Box>

                {overviewSubTab === 0 && (() => {
                  // Columns adapt to the channels actually present in the sequence
                  const hasVoiceSteps = orderedStepAnalytics.some(s => s['nodeType'] === 'voice');
                  const hasMessageSteps = orderedStepAnalytics.some(s => ['email', 'sms', 'whatsapp', 'linkedin'].includes(s['nodeType']));
                  const totalCols = 5 + (hasVoiceSteps ? 2 : 0) + (hasMessageSteps ? 2 : 0);
                  return (
                    <TableContainer>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>Step</TableCell>
                            <TableCell>Channel</TableCell>
                            <TableCell align="center">{hasVoiceSteps && !hasMessageSteps ? 'Calls Made' : 'Sent'}</TableCell>
                            {hasVoiceSteps && <TableCell align="center">Answered</TableCell>}
                            {hasVoiceSteps && <TableCell align="center">No Answer</TableCell>}
                            {hasVoiceSteps && <TableCell align="center">Passed</TableCell>}
                            <TableCell align="center">Failed</TableCell>
                            <TableCell align="center">Skipped</TableCell>
                            {hasMessageSteps && <TableCell align="center">AI Generated</TableCell>}
                            {hasMessageSteps && <TableCell align="center">Tokens</TableCell>}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {orderedStepAnalytics.length === 0 ? (
                            <TableRow><TableCell colSpan={totalCols} align="center"><Typography variant="body2" color="textSecondary" sx={{ py: 3 }}>No step data yet</Typography></TableCell></TableRow>
                          ) : orderedStepAnalytics.map((step) => {
                            const StepIcon = nodeTypeIcons[step['nodeType']] || TimelineIcon;
                            const color = nodeTypeColors[step['nodeType']] || '#6B7280';
                            const isDelay = step['nodeType'] === 'delay' || step['nodeType'] === 'end';
                            const isVoice = step['nodeType'] === 'voice';
                            return (
                              <TableRow key={step['_id']}>
                                <TableCell><Typography variant="body2" fontWeight={500}>{step['nodeName'] || 'Unnamed'}</Typography></TableCell>
                                <TableCell><Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}><StepIcon sx={{ fontSize: 16, color }} /><Typography variant="body2" sx={{ textTransform: 'capitalize', color }}>{step['nodeType']}</Typography></Box></TableCell>
                                <TableCell align="center">{isDelay ? '—' : step['sent'] || 0}</TableCell>
                                {hasVoiceSteps && <TableCell align="center" sx={{ color: (step['answered'] || 0) > 0 ? '#16a34a' : undefined, fontWeight: (step['answered'] || 0) > 0 ? 600 : undefined }}>{isVoice ? step['answered'] || 0 : '—'}</TableCell>}
                                {hasVoiceSteps && <TableCell align="center">{isVoice ? step['noAnswer'] || 0 : '—'}</TableCell>}
                                {hasVoiceSteps && <TableCell align="center" sx={{ color: (step['pass'] || 0) > 0 ? '#16a34a' : undefined, fontWeight: (step['pass'] || 0) > 0 ? 600 : undefined }}>{isVoice ? `${step['pass'] || 0}${(step['answered'] || 0) > 0 ? ` (${Math.round(((step['pass'] || 0) / step['answered']) * 100)}%)` : ''}` : '—'}</TableCell>}
                                <TableCell align="center" sx={{ color: (step['failed'] || 0) > 0 ? '#DC2626' : undefined }}>{isDelay ? '—' : step['failed'] || 0}</TableCell>
                                <TableCell align="center">{isDelay ? '—' : step['skipped'] || 0}</TableCell>
                                {hasMessageSteps && <TableCell align="center">{isDelay || isVoice ? '—' : (step['aiCount'] || 0) > 0 ? <Chip icon={<AIIcon sx={{ fontSize: '12px !important' }} />} label={`${step['aiCount']} (${step['sent'] > 0 ? Math.round((step['aiCount'] / step['sent']) * 100) : 0}%)`} size="small" sx={{ fontSize: 10, height: 20, bgcolor: '#fbfbff', color: '#120348' }} /> : '0'}</TableCell>}
                                {hasMessageSteps && <TableCell align="center">{isVoice ? '—' : (step['totalTokens'] || 0) > 0 ? step['totalTokens'].toLocaleString() : '—'}</TableCell>}
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  );
                })()}

                {overviewSubTab === 1 && (
                  <ActivityFeedTab
                    activityFeed={activityFeed}
                    activityFeedLoading={activityFeedLoading}
                    nodeTypeIcons={nodeTypeIcons}
                    nodeTypeColors={nodeTypeColors}
                  />
                )}

                {overviewSubTab === 2 && (isEmailCampaign || isVoiceCampaign) && (
                  <div className="campaign-channel-health">
                    <p className="campaign-channel-health-sub">Per-sender delivery status. Disconnected mailboxes are skipped automatically.</p>

                    {isEmailCampaign && (
                      <div className="campaign-channel-health-section">
                        <div className="campaign-channel-health-section-title">Email senders</div>
                        <table className="campaign-channel-health-table">
                          <thead>
                            <tr>
                              <th>Mailbox</th>
                              <th className="ch-num">Sent</th>
                              <th className="ch-num">Failed</th>
                              <th className="ch-num">Today</th>
                              <th>Status</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {(integrationStats['email'] || []).length === 0 ? (
                              <tr><td colSpan={6} className="campaign-channel-health-empty">No sender activity yet</td></tr>
                            ) : (integrationStats['email'] || []).map((row, i) => {
                              const isUnattributed = row['health'] === 'unattributed';
                              const badge = channelHealthBadge(row['health']);
                              const rowKey = row['integrationId'] || `unattributed-${i}`;
                              const hasFailed = (row['failed'] || 0) > 0;
                              const isExpanded = expandedFailRow === rowKey;
                              const failure = hasFailed ? classifyFailure(row) : null;
                              const errorMsg = row['lastError'] || row['connectionError'] || '';
                              return (
                                <React.Fragment key={rowKey}>
                                  <tr className={isUnattributed ? 'campaign-channel-health-muted-row' : ''}>
                                    <td>
                                      {isUnattributed
                                        ? <span className="campaign-channel-health-muted">Pre-tracking sends <span className="campaign-channel-health-hint">— older attempts aren’t attributed to a mailbox</span></span>
                                        : <span className="campaign-channel-health-mailbox">{row['accountIdentifier'] || '—'}</span>}
                                    </td>
                                    <td className="ch-num">{row['sent'] || 0}</td>
                                    <td className={`ch-num ${hasFailed ? 'ch-failed' : ''} ${hasFailed ? 'ch-failed-clickable' : ''}`}
                                      onClick={hasFailed ? () => setExpandedFailRow(isExpanded ? null : rowKey) : undefined}>
                                      {hasFailed
                                        ? <span className="ch-failed-toggle">{row['failed']} <i className={`fa fa-chevron-${isExpanded ? 'up' : 'down'} ch-failure-chevron`} /></span>
                                        : 0}
                                    </td>
                                    <td className="ch-num">{isUnattributed || row['dailySendingLimit'] == null ? '—' : `${row['sentToday'] || 0}/${row['dailySendingLimit']}`}</td>
                                    <td>
                                      {isUnattributed
                                        ? <span className="campaign-channel-health-hint">—</span>
                                        : <span className={`campaign-channel-health-badge ch-badge-${badge.tone}`} title={row['connectionError'] || ''}><i className={`fa ${badge.icon}`} /> {badge.label}</span>}
                                    </td>
                                    <td className="campaign-channel-health-actions">
                                      {!isUnattributed && row['integrationId'] && (
                                        <button className="campaign-channel-health-action campaign-channel-health-test" disabled={mailboxTesting[row['integrationId']]} onClick={() => handleTestMailbox(row['integrationId'])}>
                                          {mailboxTesting[row['integrationId']] ? <i className="fa fa-spinner fa-spin" /> : 'Test'}
                                        </button>
                                      )}
                                      {row['health'] === 'needs_reconnect' && (
                                        <button className="campaign-channel-health-action" onClick={() => routerHistory.push(getWorkspacePath('/settings?tab=integrations-apps', currentWorkspace?.['_id']))}>Reconnect</button>
                                      )}
                                    </td>
                                  </tr>
                                  {isExpanded && failure && (
                                    <tr className="ch-failure-detail-row">
                                      <td colSpan={6}>
                                        <div className="ch-failure-detail-inner">
                                          <span className={`ch-failure-category ch-failure-cat-${failure['tone']}`}>{failure['category']}</span>
                                          {errorMsg && <span className="ch-failure-message" title={errorMsg}>{errorMsg}</span>}
                                          {failure['hint'] && <span className="ch-failure-hint">{failure['hint']}</span>}
                                          {row['health'] === 'needs_reconnect' && row['integrationId'] && (
                                            <button className="campaign-channel-health-action ch-failure-reconnect-btn" onClick={() => routerHistory.push(getWorkspacePath('/settings?tab=integrations-apps', currentWorkspace?.['_id']))}>
                                              Reconnect
                                            </button>
                                          )}
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </React.Fragment>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    )}

                    {isVoiceCampaign && (
                      <div className="campaign-channel-health-section">
                        <div className="campaign-channel-health-section-title">Call agents &amp; numbers</div>
                        <table className="campaign-channel-health-table">
                          <thead>
                            <tr>
                              <th>Agent</th>
                              <th>Name</th>
                              <th>Number</th>
                              <th className="ch-num">Attempted</th>
                              <th className="ch-num">Connected</th>
                              <th className="ch-num">Failed</th>
                            </tr>
                          </thead>
                          <tbody>
                            {voiceRows.length === 0 ? (
                              <tr><td colSpan={6} className="campaign-channel-health-empty">No call activity yet</td></tr>
                            ) : voiceRows.map((row, i) => (
                              <tr key={i}>
                                <td className="campaign-channel-health-mailbox">{row['agentId'] ? <span className="campaign-channel-health-link" onClick={() => openAgentInNewTab(row['agentId'])}>{row['agentName'] || '—'}</span> : (row['agentName'] || '—')}</td>
                                <td className="campaign-channel-health-mailbox">{row['phoneId'] ? <span className="campaign-channel-health-link" onClick={() => openPhoneIntegrationInNewTab(row)}>{row['nickName'] || '—'}</span> : (row['nickName'] || '—')}</td>
                                <td>{row['phoneNumber'] || '—'}</td>
                                <td className="ch-num">{row['attempted'] || 0}</td>
                                <td className="ch-num">{row['connected'] || 0}</td>
                                <td className={`ch-num ${(row['failed'] || 0) > 0 ? 'ch-failed' : ''}`}>{row['failed'] || 0}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                )}
              </Paper>
            </div>
          )}

          {activeTab === 1 && (
            <div className='content'>
              <div className='main-container'>
                <div className='bottom-content-area'>
                  <div className='tabs-content'>
                    <div className='content'>
                      <div className='allemails-area'>
                        <div className='workflow-table-box'>
                          {/* Search and Filter Bar */}
                          {/* Stats chips */}
                          {/* Status Filter Dropdown */}
                          <div className="table-container filters-table workflow-table">
                            <div className='header-table-filters advanced-table-filters'>
                              <div className='left-area'>
                                <div className='filter-box'>
                                  <div className='searchbox'>
                                    <TextField
                                      fullWidth
                                      hiddenLabel
                                      size="small"
                                      name='search'
                                      variant="standard"
                                      value={contactSearch}
                                      onChange={(e) => setContactSearch(e.target.value)}
                                      placeholder="Search contacts..."
                                    />
                                    <i className='icon'>
                                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5.82319 10.6464C3.16455 10.6464 1 8.48183 1 5.82319C1 3.16455 3.16455 1 5.82319 1C8.48183 1 10.6464 3.16455 10.6464 5.82319C10.6464 8.48183 8.48183 10.6464 5.82319 10.6464ZM5.82319 1.70583C3.55041 1.70583 1.70583 3.55511 1.70583 5.82319C1.70583 8.09127 3.55041 9.94055 5.82319 9.94055C8.09597 9.94055 9.94055 8.09127 9.94055 5.82319C9.94055 3.55511 8.09597 1.70583 5.82319 1.70583Z" fill="#505258" stroke="#505258" stroke-width="0.236842" />
                                        <path d="M13.3182 13.7068C13.2245 13.7069 13.1307 13.6725 13.0566 13.5985L9.10425 9.63167C8.96097 9.48877 8.96065 9.25192 9.10355 9.10864C9.24646 8.96536 9.4833 8.96505 9.62658 9.10795L13.5789 13.0748C13.7222 13.2177 13.7225 13.4546 13.5796 13.5979C13.5057 13.672 13.412 13.7066 13.3182 13.7068Z" fill="#505258" stroke="#505258" stroke-width="0.236842" />
                                      </svg>
                                    </i>
                                  </div>
                                  <div className='filter-box'>
                                    <ul>
                                      <Tooltip title="All Contacts" placement="bottom" arrow componentsProps={{ tooltip: { className: 'ca-pill-tooltip' } }}>
                                        <li className={`ca-filter-pill${!contactStatusFilter.length ? ' ca-filter-pill-active' : ''}`} onClick={() => { setContactStatusFilter([]); setContactPage(0); contactsFetchKeyRef.current = ''; }}>
                                          <i className="icon"><img src={multipleUsersImg} alt='' /></i>
                                          {contactsTotal || (metrics['totalContacts'] || 0)}
                                        </li>
                                      </Tooltip>
                                      <Tooltip title={isVoiceCampaign ? 'Calls Answered' : 'Replies'} placement="bottom" arrow componentsProps={{ tooltip: { className: 'ca-pill-tooltip' } }}>
                                        <li className={`ca-filter-pill${contactStatusFilter.includes(isVoiceCampaign ? 'call_answered' : 'reply_received') ? ' ca-filter-pill-active' : ''}`} onClick={() => toggleStatusFilter(isVoiceCampaign ? 'call_answered' : 'reply_received')}>
                                          <i className="icon"><img src={handshakeImg} alt='' /></i>
                                          {isVoiceCampaign ? (countMetrics['callsAnswered'] || 0) : (countMetrics['emailsReplied'] || totalReplies)}
                                        </li>
                                      </Tooltip>
                                      <Tooltip title={isVoiceCampaign ? 'Voicemails' : isEmailCampaign ? 'Bounced' : 'SMS Replied'} placement="bottom" arrow componentsProps={{ tooltip: { className: 'ca-pill-tooltip' } }}>
                                        <li className={`ca-filter-pill${contactStatusFilter.includes('bounced') ? ' ca-filter-pill-active' : ''}`} onClick={() => { if (isEmailCampaign) toggleStatusFilter('bounced'); }}>
                                          <i className="icon"><img src={brokenHeartImg} alt='' /></i>
                                          {isVoiceCampaign ? (countMetrics['callsVoicemail'] || 0) : isEmailCampaign ? (countMetrics['emailsBounced'] || 0) : (countMetrics['smsReplied'] || 0)}
                                        </li>
                                      </Tooltip>
                                      {isEmailCampaign && (
                                        <Tooltip title="Unsubscribed" placement="bottom" arrow componentsProps={{ tooltip: { className: 'ca-pill-tooltip' } }}>
                                          <li className={`ca-filter-pill${contactStatusFilter.includes('opted_out') ? ' ca-filter-pill-active' : ''}`} onClick={() => toggleStatusFilter('opted_out')}>
                                            <i className="icon"><img src={sadImg} alt='' /></i>
                                            {contactStats['opted_out'] || 0}
                                          </li>
                                        </Tooltip>
                                      )}
                                      <Tooltip title="Completed" placement="bottom" arrow componentsProps={{ tooltip: { className: 'ca-pill-tooltip' } }}>
                                        <li className={`ca-filter-pill${contactStatusFilter.includes('completed') ? ' ca-filter-pill-active' : ''}`} onClick={() => toggleStatusFilter('completed')}>
                                          <i className="icon"><img src={checkedImg} alt='' /></i>
                                          {contactStats['completed'] || 0}
                                        </li>
                                      </Tooltip>
                                    </ul>
                                  </div>
                                  {/* <button
                                    size="small"
                                    className="btn-style-edit-tablelist"
                                    onClick={() => setShowFilterModal(true)}
                                  >
                                    <i className="icon">
                                      <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.74735 8.70926H1.80211L3.26072 8.57262C3.46483 8.55238 3.654 8.46129 3.79836 8.31453L9.30425 2.71753C9.56312 2.45438 9.70749 2.1052 9.70749 1.73578C9.70749 1.36636 9.56312 1.01718 9.30425 0.754026L8.9508 0.394725C8.43307 -0.131575 7.53201 -0.131575 7.01428 0.394725L6.31236 1.10827L1.51337 5.98667C1.369 6.13342 1.2794 6.32572 1.26446 6.53321L1.13005 8.01596C1.11512 8.2032 1.17983 8.38538 1.30927 8.52202C1.42874 8.64347 1.58307 8.70926 1.74735 8.70926ZM7.98503 0.743905C8.14433 0.743905 8.30363 0.804632 8.42311 0.931147L8.77656 1.29045C8.83472 1.34857 8.88092 1.41788 8.91245 1.49434C8.94398 1.5708 8.96022 1.65287 8.96022 1.73578C8.96022 1.81868 8.94398 1.90076 8.91245 1.97722C8.88092 2.05368 8.83472 2.12299 8.77656 2.18111L8.33848 2.62644L7.10887 1.37648L7.54695 0.931147C7.66642 0.809693 7.82573 0.743905 7.98503 0.743905ZM2.00621 6.60406C2.00621 6.57369 2.02115 6.54839 2.04106 6.52815L6.5762 1.9129L7.80581 3.16286L3.27068 7.77305C3.27068 7.77305 3.22089 7.80847 3.196 7.80847L1.88674 7.92993L2.00621 6.599V6.60406ZM10.7031 10.3236C10.7031 10.5311 10.5339 10.7031 10.3298 10.7031H0.373365C0.169259 10.7031 0 10.5311 0 10.3236C0 10.1161 0.169259 9.94404 0.373365 9.94404H10.3298C10.5339 9.94404 10.7031 10.1161 10.7031 10.3236Z" fill="#120348" />
                                      </svg>
                                    </i>
                                  </button> */}
                                </div>
                              </div>
                              <div className='right-deals-filtes'>
                                <div className='filter-deals-owner mr-3'>
                                  <FormControl size="small">
                                    <Select
                                      multiple
                                      value={contactStatusFilter}
                                      displayEmpty
                                      onChange={(e) => { const value = e['target']['value']; setContactStatusFilter(value.includes('') ? [] : value); setContactPage(0); contactsFetchKeyRef.current = ''; }}
                                      renderValue={(selected) => !selected.length
                                        ? <><i className="icon"><AllStatusIcon /></i>All Status ({contactsTotal || campaignContactsTotal})</>
                                        : `${contactStatusOptions.find(o => o['value'] === selected[0])?.['label'] || selected[0]}${selected.length > 1 ? ` +${selected.length - 1}` : ''}`}
                                      MenuProps={{ PaperProps: { className: 'campaign-dropdown-paper' } }}
                                    >
                                      <MenuItem value="">
                                        <i className="icon"><AllStatusIcon /></i>
                                        All Status ({contactsTotal || campaignContactsTotal})
                                      </MenuItem>
                                      {contactStatusOptions.map(o => (
                                        <MenuItem key={o['value']} value={o['value']}>
                                          <i className="icon">{o['icon']}</i>
                                          {o['label']} ({o['count']})
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </div>
                                <div className='filter-deals-owner'>
                                  <FormControl size="small">
                                    <Select
                                      value={selectedOwner}
                                      onChange={(e) => { setSelectedOwner(e.target.value); setOwnerSearch(''); setContactPage(0); contactsFetchKeyRef.current = ''; }}
                                      displayEmpty
                                      open={ownerDropdownOpen}
                                      onOpen={() => setOwnerDropdownOpen(true)}
                                      onClose={() => { setOwnerDropdownOpen(false); setOwnerSearch(''); }}
                                      renderValue={(selected) => (
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
                                          {selected === 'All User' ? (
                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                              <circle cx="7" cy="5" r="2.5" stroke="#120348" strokeWidth="1.5" />
                                              <path d="M2 12C2 9.79 4.24 8 7 8s5 1.79 5 4" stroke="#120348" strokeWidth="1.5" strokeLinecap="round" />
                                            </svg>
                                          ) : (
                                            <Avatar sx={{ width: 14, height: 14, fontSize: 10, bgcolor: getColor(selected) }}>{getInitial(selected)}</Avatar>
                                          )}
                                          {selected}
                                        </Box>
                                      )}
                                    >
                                      <ListSubheader onClick={(e) => e.stopPropagation()} onKeyDown={(e) => e.stopPropagation()}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                          <SearchIcon />
                                          <input autoFocus type="text" placeholder="Search by User..." value={ownerSearch} onChange={(e) => setOwnerSearch(e.target.value)}
                                            style={{ border: 'none', outline: 'none', background: 'transparent', fontSize: 13, width: '100%', fontFamily: 'inherit', height: '25px' }} />
                                        </Box>
                                      </ListSubheader>
                                      <MenuItem value="All User">
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, width: '100%' }}>
                                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                            <circle cx="7" cy="5" r="2.5" stroke="#120348" strokeWidth="1.5" />
                                            <path d="M2 12C2 9.79 4.24 8 7 8s5 1.79 5 4" stroke="#120348" strokeWidth="1.5" strokeLinecap="round" />
                                          </svg>
                                          <Typography sx={{ fontSize: 13.5, fontWeight: selectedOwner === 'All User' ? 600 : 400, color: selectedOwner === 'All User' ? '#120348' : '#374151', flex: 1 }}>All User</Typography>
                                        </Box>
                                      </MenuItem>
                                      {filteredUsers.length === 0 && ownerSearch ? (
                                        <MenuItem disabled>
                                          <Typography sx={{ fontSize: 13, color: '#9CA3AF', width: '100%', textAlign: 'center' }}>No results</Typography>
                                        </MenuItem>
                                      ) : (
                                        filteredUsers.map((email) => (
                                          <MenuItem key={email} value={email}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, width: '100%' }}>
                                              <Avatar sx={{ width: 24, height: 24, fontSize: 11, bgcolor: getColor(email) }}>{getInitial(email)}</Avatar>
                                              <Typography sx={{ fontSize: 13.5, fontWeight: selectedOwner === email ? 600 : 400, color: selectedOwner === email ? '#120348' : '#374151', flex: 1 }}>{email}</Typography>
                                            </Box>
                                          </MenuItem>
                                        ))
                                      )}
                                    </Select>
                                  </FormControl>
                                </div>

                                <div className='filter-deals-owner'>
                                  <button
                                    size="small"
                                    className="btn-style-new ml-2"
                                    onClick={() => setShowAdvancedFilter(true)}
                                  >
                                    <i className="icon">
                                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.38173 13.2126C6.10173 13.2126 5.82757 13.1426 5.5709 13.0026C5.05756 12.7168 4.7484 12.1976 4.7484 11.6143V8.5226C4.7484 8.23093 4.5559 7.79343 4.37506 7.57176L2.1934 5.26176C1.8259 4.89426 1.5459 4.26426 1.5459 3.79176V2.4501C1.5459 1.51676 2.25173 0.787598 3.15007 0.787598H10.8501C11.7367 0.787598 12.4542 1.5051 12.4542 2.39176V3.6751C12.4542 4.2876 12.0867 4.98176 11.7426 5.32593L9.21673 7.5601C8.97173 7.76426 8.77923 8.21343 8.77923 8.5751V11.0834C8.77923 11.6026 8.45256 12.2034 8.04423 12.4484L7.23923 12.9676C6.97673 13.1309 6.67923 13.2126 6.38173 13.2126ZM3.15007 1.6626C2.74173 1.6626 2.4209 2.00676 2.4209 2.4501V3.79176C2.4209 4.0076 2.5959 4.4276 2.81756 4.64926L5.04007 6.98843C5.33757 7.35593 5.62923 7.96843 5.62923 8.51676V11.6084C5.62923 11.9876 5.89173 12.1743 6.00256 12.2326C6.24756 12.3668 6.54506 12.3668 6.77256 12.2268L7.5834 11.7076C7.74673 11.6084 7.91006 11.2934 7.91006 11.0834V8.5751C7.91006 7.95093 8.2134 7.2626 8.6509 6.8951L11.1476 4.68426C11.3459 4.48593 11.5851 4.01343 11.5851 3.66926V2.39176C11.5851 1.98926 11.2584 1.6626 10.8559 1.6626H3.15007Z" fill="currentColor" />
                                        <path d="M3.49989 6.27082C3.41823 6.27082 3.34239 6.24749 3.26656 6.20666C3.06239 6.07832 2.99823 5.80416 3.12656 5.59999L6.00239 0.991658C6.13073 0.787491 6.39906 0.723324 6.60323 0.851658C6.80739 0.979991 6.87156 1.24832 6.74323 1.45249L3.86739 6.06082C3.78573 6.19499 3.64573 6.27082 3.49989 6.27082Z" fill="currentColor" />
                                      </svg>
                                    </i>
                                    Filters
                                  </button>
                                </div>
                                <div className='filter-deals-owner'>
                                  <AudienceColumn
                                    className="ml-2 campaign-contacts-export-btn"
                                    exportFields={exportFieldOptions({ isVoiceCampaign, isEmailCampaign })}
                                    exporting={exportingContacts}
                                    onExport={handleExportContacts}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          {(() => {
                            const allContactFilters = activeContactFilters?.definition?.filterGroups?.flatMap(g => (g['filters'] || []).map(f => ({ ...f, groupId: g['id'] }))) || [];
                            if (!allContactFilters.length) return null;
                            return (
                              <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '8px', padding: '8px 12px 4px' }}>
                                {allContactFilters.map(filter => {
                                  let displayValue = filter['value'];
                                  if (Array.isArray(displayValue)) displayValue = displayValue.join(', ');
                                  else if (typeof displayValue === 'object' && displayValue !== null) {
                                    const trueKeys = Object.keys(displayValue).filter(key => displayValue[key]);
                                    displayValue = displayValue['label'] || displayValue['name'] || (trueKeys.length > 0 ? trueKeys.join(', ') : JSON.stringify(displayValue));
                                  }
                                  return (
                                    <Chip
                                      size="small"
                                      key={filter['id']}
                                      label={`${filter['property']?.['label'] || filter['property']?.['name']} ${filter['operator']?.['label'] || ''} ${displayValue || ''}`}
                                      onDelete={() => handleRemoveContactFilter(filter['groupId'], filter['id'])}
                                      sx={{ background: 'var(--secondary-color)', color: 'var(--primary-color)', border: 'none', fontSize: '12px', '& .MuiChip-deleteIcon': { color: '#E94033' } }}
                                    />
                                  );
                                })}
                                <Button size="small" onClick={handleClearContactFilters}>Clear All</Button>
                              </div>
                            );
                          })()}
                          <div className="campaigns-table">
                            <style>{tableStyles}</style>
                            <DataTable
                              columns={contactColumns(campaign, setSelectedContact, selectedContact, { isVoiceCampaign, isEmailCampaign, isSMSCampaign, isLinkedInCampaign }, currentWorkspace?.['_id'])}
                              data={filteredContacts}
                              fixedHeader
                              keyField="_id"
                              selectableRows
                              persistTableHead
                              pagination
                              paginationServer
                              fixedHeaderScrollHeight={headerScrollHeight}
                              className={`table-sellagent table-workflow audience-table ${responsiveClass}`}
                              paginationTotalRows={campaignContactsTotal}
                              paginationDefaultPage={contactPage + 1}
                              paginationPerPage={contactLimit}
                              paginationRowsPerPageOptions={[10, 20, 50, 100, 250, 500]}
                              onChangePage={(page) => setContactPage(page - 1)}
                              onChangeRowsPerPage={(newLimit) => { setContactLimit(newLimit); setContactPage(0); }}
                              onRowClicked={(row) => setSelectedContact(row)}
                              pointerOnHover
                              conditionalRowStyles={[
                                {
                                  when: row => row._id === selectedContact?._id,
                                  style: { backgroundColor: '#F0F7FF' },
                                },
                              ]}
                              highlightOnHover
                              dense={false}
                              progressPending={campaignContactsLoading}
                              progressComponent={<TableAnimationFiles />}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* ── Advanced Filter Modal ── */}
      <AdvancedFilterModal
        objectType="campaignContacts"
        isOpen={showAdvancedFilter}
        onClose={() => setShowAdvancedFilter(false)}
        onGetData={handleAdvancedFilterApply}
        isolate={true}
        initialFilters={activeContactFilters?.definition}
      />

      {/* Activity Log Drawer */}
      <Drawer anchor="right" open={auditLogOpen} onClose={() => setAuditLogOpen(false)} PaperProps={{ sx: { width: { xs: '100vw', sm: 420 } } }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <Box className="ca-log-drawer-header" sx={{ background: 'var(--secondary-color)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 3, py: 2, borderBottom: '1px solid #e8ecf2', flexShrink: 0 }}>
            <Typography fontWeight={600} fontSize={15} color="var(--primary-color)">Activity Log</Typography>
            <IconButton size="small" onClick={() => setAuditLogOpen(false)}><CloseIcon fontSize="small" /></IconButton>
          </Box>
          <Box sx={{ flex: 1, overflow: 'auto', px: 3, py: 2 }}>
            <CampaignAuditLogTab entries={auditLog} loading={auditLogLoading} />
          </Box>
        </Box>
      </Drawer>

      {/* Contact Timeline Drawer */}
      <Drawer anchor="right" open={!!selectedContact} onClose={() => setSelectedContact(null)} PaperProps={{ sx: { width: { xs: '100vw', sm: 550 } } }}>
        {selectedContact && (() => {
          const cc = selectedContact;
          const contact = cc['contactId'] || {};
          const name = [contact['firstName'], contact['lastName']].filter(Boolean).join(' ') || contact['email'] || 'Unknown';
          const initials = (contact['firstName']?.[0] || '') + (contact['lastName']?.[0] || '') || '?';
          const cfg = statusConfig[cc['status']] || statusConfig['pending'];
          // One stat line per channel the contact actually went through, instead of a hardcoded email count
          const CHANNEL_STAT_LABELS = { email: ['Email Sent', 'Emails Sent'], voice: ['Call Made', 'Calls Made'], sms: ['SMS Sent', 'SMS Sent'], whatsapp: ['Message Sent', 'Messages Sent'], linkedin: ['Message Sent', 'Messages Sent'] };
          const channelStats = Object.entries(CHANNEL_STAT_LABELS).map(([type, [singular, plural]]) => {
            const count = (cc['executionHistory'] || []).filter(h => h['nodeType'] === type && h['status'] === 'success').length;
            return { type, count, label: count === 1 ? singular : plural };
          }).filter(s => s['count'] > 0);
          const totalTokens = cc['tokenUsage']?.['totalTokens'] || 0;

          return (
            <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', background: 'var(--secondary-color)' }}>

              {/* ── Header ── */}
              <Box sx={{
                px: 3, py: 2.5,
                borderBottom: '1px solid #0000000F',
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                background: 'color-mix(in srgb, #817fda 10%, var(--secondary-color))',
              }}>
                <Typography sx={{ fontSize: 18, fontWeight: 700, color: '#120348', letterSpacing: '-0.3px' }}>
                  Contact Timeline
                </Typography>
                <IconButton
                  size="small"
                  onClick={() => setSelectedContact(null)}
                  sx={{ color: '#6B7280', '&:hover': { bgcolor: '#F3F0FF', color: '#120348' } }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>

              {/* ── Contact Info ── */}
              <div className="contact-info-data">
                {/* Row: Avatar + Info + Status + Stats */}
                <div className="left-content">
                  <div className="img-box">
                    <Avatar sx={{ width: 48, height: 48, fontSize: 16, bgcolor: '#E5E7EB', color: '#374151', flexShrink: 0 }}>
                      {initials}
                    </Avatar>
                  </div>

                  {/* Name / Email / Phone / LinkedIn / Company */}
                  <div className="text-box">
                    <h4>{name}</h4>
                    {contact['email'] && (
                      <p className="email-text">{contact['email']}</p>
                    )}
                    {contact['phone'] && (
                      <p className="ct-meta-row"><i className="fa fa-phone ct-meta-icon" />{contact['phone']}</p>
                    )}
                    {contact['linkedinUrl'] && (
                      <a className="ct-meta-row ct-linkedin-link" href={contact['linkedinUrl']} target="_blank" rel="noopener noreferrer">
                        <svg className="ct-meta-icon" width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" /></svg>
                        LinkedIn
                      </a>
                    )}
                    {contact['company'] && (
                      <p className="ct-meta-row"><i className="fa fa-building ct-meta-icon" />{contact['company']}</p>
                    )}
                  </div>
                </div>
                {/* Status + Stats stacked on right */}
                <div className="right-content">
                  <Chip
                    label={cfg['label']}
                    size="small"
                    sx={{ bgcolor: cfg['bg'], color: cfg['color'], fontWeight: 500, fontSize: 11 }}
                    icon={<cfg.icon sx={{ fontSize: '13px !important', color: `${cfg['color']} !important` }} />}
                  />
                  {channelStats.map(s => (
                    <p key={s['type']}>{s['count']} {s['label']}</p>
                  ))}
                  {totalTokens > 0 && (
                    <p>{totalTokens} Tokens</p>
                  )}

                  {cc['errorCount'] > 0 && (
                    <p>{cc['errorCount']} Error{cc['errorCount'] !== 1 ? 's' : ''}</p>
                  )}
                </div>
              </div>

              {/* ── Timeline Content ── */}
              <Box sx={{ flex: 1, overflow: 'auto' }}>
                <ContactExecutionHistory
                  history={cc['executionHistory'] || []}
                  sequenceNodes={campaign['sequence']?.['nodes'] || []}
                  sequenceEdges={campaign['sequence']?.['edges'] || []}
                  entryNodeId={campaign['sequence']?.['entryNodeId']}
                  currentNodeId={cc['currentNodeId']}
                  nextProcessAt={cc['nextProcessAt']}
                  contactStatus={cc['status']}
                  enrolledAt={cc['enrolledAt']}
                  completedAt={cc['completedAt']}
                  emailEvents={cc['emailEvents'] || []}
                />
              </Box>

            </Box>
          );
        })()}
      </Drawer>
    </div>
  )
}


const tableStyles = `
          .table-sellagent input[type="checkbox"] {
            width: 13px;
          height: 13px;
          cursor: pointer;
          accent-color: #cbd6e2;
          transform: scale(1);
          opacity: 0.45;
  }

          .table-sellagent input[type="checkbox"]:checked {
            opacity: 1;
          accent-color: var(--primary-color);
  }

          .rdt_TableRow {
            transition: background-color 0.15s ease;
  }

          .rdt_TableRow:hover {
            background - color: #f5f5f5;
  }

          .table-container {
            position: relative;
  }
          `;

function formatCallDuration(minutes) {
  const totalSeconds = Math.round(parseFloat(minutes) * 60);
  const m = Math.floor(totalSeconds / 60);
  const s = totalSeconds % 60;
  if (m === 0) return `${s}s`;
  return s === 0 ? `${m}m` : `${m}m ${s}s`;
}

function resolveDatePayload(id, dateRange) {
  if (!dateRange || dateRange['preset'] === 'all_time' || !dateRange['preset']) return id;
  if (dateRange['preset'] === 'custom') {
    return { id, startDate: dateRange['start'] ? new Date(dateRange['start']).toISOString() : undefined, endDate: dateRange['end'] ? new Date(dateRange['end']).toISOString() : undefined };
  }
  const now = new Date();
  let start;
  let end = now;
  if (dateRange['preset'] === 'today') { start = new Date(now); start.setHours(0, 0, 0, 0); }
  else if (dateRange['preset'] === 'yesterday') { start = new Date(now); start.setDate(now.getDate() - 1); start.setHours(0, 0, 0, 0); end = new Date(start); end.setHours(23, 59, 59, 999); }
  else if (dateRange['preset'] === 'last_7_days') { start = new Date(now); start.setDate(now.getDate() - 7); }
  else if (dateRange['preset'] === 'last_4_weeks') { start = new Date(now); start.setDate(now.getDate() - 28); }
  else if (dateRange['preset'] === 'last_3_months') { start = new Date(now); start.setMonth(now.getMonth() - 3); }
  else if (dateRange['preset'] === 'week_to_date') { start = new Date(now); start.setDate(now.getDate() - now.getDay()); start.setHours(0, 0, 0, 0); }
  else if (dateRange['preset'] === 'month_to_date') { start = new Date(now.getFullYear(), now.getMonth(), 1); }
  else if (dateRange['preset'] === 'year_to_date') { start = new Date(now.getFullYear(), 0, 1); }
  return { id, startDate: start ? start.toISOString() : undefined, endDate: end.toISOString() };
}

const DATE_PRESETS = [
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'last_7_days', label: 'Last 7 days' },
  { value: 'last_4_weeks', label: 'Last 4 weeks' },
  { value: 'last_3_months', label: 'Last 3 months' },
  { value: 'week_to_date', label: 'Week to date' },
  { value: 'month_to_date', label: 'Month to date' },
  { value: 'year_to_date', label: 'Year to date' },
  { value: 'all_time', label: 'All time' },
];

const DATE_PRESET_LABEL = (preset, customRange) => {
  if (preset === 'custom') {
    const [s, e] = customRange;
    if (s && e) return `${s.toLocaleDateString()} – ${e.toLocaleDateString()}`;
    return 'Custom range';
  }
  return DATE_PRESETS.find(p => p.value === preset)?.label || 'All time';
};

const ACTION_META = {
  created: { icon: '✦', color: '#7C3AED', label: 'Campaign created' },
  launched: { icon: '▶', color: '#16a34a', label: 'Campaign launched' },
  paused: { icon: '⏸', color: '#F7931A', label: 'Campaign paused' },
  resumed: { icon: '▶', color: '#16a34a', label: 'Campaign resumed' },
  completed: { icon: '✓', color: '#2563EB', label: 'Campaign completed' },
  auto_completed: { icon: '✓', color: '#2563EB', label: 'Auto-completed' },
  restarted: { icon: '↺', color: '#7C3AED', label: 'Campaign restarted' },
  duplicated: { icon: '⊕', color: '#6B7280', label: 'Campaign duplicated' },
  deleted: { icon: '✕', color: '#EF4D56', label: 'Campaign deleted' },
  name_changed: { icon: '✎', color: '#2563EB', label: 'Name changed' },
  audience_updated: { icon: '⊞', color: '#2563EB', label: 'Audience updated' },
  sequence_edited: { icon: '⊟', color: '#2563EB', label: 'Sequence edited' },
  settings_changed: { icon: '⚙', color: '#2563EB', label: 'Settings changed' },
  channels_changed: { icon: '⊕', color: '#2563EB', label: 'Channels updated' },
  integration_changed: { icon: '⊕', color: '#2563EB', label: 'Integrations updated' },
  test_sent: { icon: '✉', color: '#F7931A', label: 'Test sent' },
  process_triggered: { icon: '▶', color: '#F7931A', label: 'Batch triggered' },
};

function formatRelativeTime(dateStr) {
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 7) return `${days}d ago`;
  return new Date(dateStr).toLocaleDateString();
}

function CampaignAuditLogTab({ entries, loading }) {
  if (loading) return (
    <div className="ca-log-empty"><CircularProgress size={28} sx={{ color: 'var(--primary-color)' }} /></div>
  );
  if (!entries || entries.length === 0) return (
    <div className="ca-log-empty"><Typography variant="body2" color="textSecondary">No activity recorded yet</Typography></div>
  );

  return (
    <div className="ca-log-list">
      {entries.map((entry) => {
        const meta = ACTION_META[entry['action']] || { icon: '•', color: '#6B7280', label: entry['action'] };
        const actor = entry['userId'];
        const actorName = actor ? `${actor['firstName'] || ''} ${actor['lastName'] || ''}`.trim() || actor['email'] : 'System';
        const initials = actor ? ((actor['firstName']?.[0] || '') + (actor['lastName']?.[0] || '')).toUpperCase() || '?' : 'S';
        const label = entry['label'] || meta.label;
        return (
          <div key={entry['_id']} className="ca-log-entry">
            <div className="ca-log-icon" style={{ background: meta.color + '18', color: meta.color }}>{meta.icon}</div>
            <div className="ca-log-body">
              <div className="ca-log-row">
                <span className="ca-log-label">{label}</span>
                {entry['changes'] && entry['changes']['from'] !== undefined && (
                  <span className="ca-log-change">{String(entry['changes']['from'])} → {String(entry['changes']['to'])}</span>
                )}
                {entry['changes'] && entry['changes']['delta'] !== undefined && (
                  <span className="ca-log-change">{entry['changes']['delta'] > 0 ? `+${entry['changes']['delta']}` : entry['changes']['delta']} node{Math.abs(entry['changes']['delta']) !== 1 ? 's' : ''}</span>
                )}
              </div>
              <div className="ca-log-meta">
                <div className="ca-log-avatar">{initials}</div>
                <span className="ca-log-actor">{actorName}</span>
                <span className="ca-log-time">{formatRelativeTime(entry['createdAt'])}</span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default CampaignAnalytics;

